import React, { useEffect, useRef, useState } from "react";
import { useResponsive } from "../../hook/useResponsive";
import { useDialogFocus, useFormKeyboard } from "../../hook/useFormKeyboard";
import {
  subscribeWeb,
  unsubscribeWeb,
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
} from "../../services/navigate.service";
import {
  extractValues,
  updateUrlParams,
  validateNoSpecialChars,
  validateOnlyNumbersNotThree,
  validatePhoneNumber,
} from "../../validation/ValidationInput";
import { getCountries } from "../../services/country.service";
import UploadIcon from "../../images/UploadIcon";
import {
  deleteUserCompany,
  getDetailCompanies,
  getUser,
  removeInviteAccountant,
  sentInviteAccountant,
  updateDetialCompanies,
} from "../../services/company.service";
import {
  getCompanyBankDetailList,
  createCompanyBankDetail,
  updateCompanyBankDetail,
  deleteCompanyBankDetail,
  CompanyBankDetailPayload,
} from "../../services/companyBankDetail.service";
import CloseIcon from "../../images/CloseIcon";
import PopupLocation from "../../components/PopupLocation";
import { deleteLocations, getLocations } from "../../services/locations.services";
import {
  deleteFloorPlan,
  getListFloorPlan,
} from "../../services/floorPlan.service";
import { showToast } from "../../services/toast.service";
import { describeApiError, showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import PhotoIcon from "../../images/PhotoIcon";
import PlusIcon from "../../images/PlusIcon";
import DeleteIconV2 from "../../images/DeleteIconV2";
import EditIconV2 from "../../images/EditIconV2";
import TableCompanyReport from "../../components/TableCompanyReport";
import TableCompanyReportMobile from "../../components/TableCompanyReportMobile";
import { DropdownSearch } from "../../components/DropdownSearch";
import BackIcon from "../../images/BackIcon";
import LoadingV2 from "../../components/LoadingV2";
import CompanyMobile from "./CompanyMobile";
import {
  createServiceCharge,
  deleteServiceCharge,
  getServiceChargeById,
  getServiceChargeList,
  updateServiceCharge,
} from "../../services/serviceCharge";
import {
  createGratuitySetting,
  deleteGratuitySetting,
  getGratuitySettingById,
  getGratuitySettingList,
  updateGratuitySetting,
} from "../../services/gratuity";
import { getGroupTax } from "../../services/tax.services";
import {
  GRATUITY_OPTION_TYPES,
  GRATUITY_PERCENT_BASES,
  GRATUITY_PROMPT_MODES,
  GratuityFormState,
  GratuityRecord,
  GratuityYesNoKey,
  emptyGratuityForm,
  gratuityFormFromRecord,
  gratuityFormProblem,
  gratuityOptionSummary,
  gratuityPayloadFromForm,
  labelOf,
  moveGratuityOption,
  newGratuityOptionRow,
  normalizeGratuity,
  patchGratuityOption,
  removeGratuityOption,
  setDefaultGratuityOption,
  visiblePages,
} from "./gratuity";
const Company = () => {
  interface Country {
    id: string;
    code: string;
    name: string;
  }
  const initalFilter = {
    page: 1,
    limit: 50,
    searchValue: "",
    sort: "DESC",
  };
  const preLanguage = localStorage.getItem("preLanguage") || "";
  // The locale this render shows, so an error message matches the copy around it.
  const locale = localStorage.getItem("language") || "en";
  const [language, setLanguage] = useState<any>(null);
  const [listPermission, setListPermission] = useState<any>();
  const inforTable: any = {
    title:
      language && language?.["No floor plans yet"]
        ? language?.["No floor plans yet"]
        : "No floor plans yet",
    desc:
      language &&
        language?.[
        `Create and manage Floor Plans (e.g., Restaurant, Bar, Terrace) to set 
location-specific menus, pricing, and revenue reports.`
        ]
        ? language?.[
        `Create and manage Floor Plans (e.g., Restaurant, Bar, Terrace) to set 
location-specific menus, pricing, and revenue reports.`
        ]
        : `Create and manage Floor Plans (e.g., Restaurant, Bar, Terrace) to set 
location-specific menus, pricing, and revenue reports.`,
  };
  const { isMobile, getWidth } = useResponsive();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showPopupBilling, setShowPopupBilling] = useState<boolean>(false);
  const [listLocation, setListLocation] = useState<any>();
  const [listFloorPlan, setListFloorPlan] = useState<any>();
  const [listUser, setListUser] = useState<any>();
  const [formValues, setFormValues] = useState<any>({
    fiscalNumber: "",
    taxCode: "",
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    webUrl: "",
    invoicePrefix: "",
  });
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [idDelete, setIdDelete] = useState<string>("");
  const [formValuesInvite, setFormValuesInvite] = useState<any>({
    firstName: "",
    lastName: "",
    emailAddress: "",
  });
  const [filterBilling, setFilterBilling] = useState<any>(initalFilter);
  const [filterUsers, setFilterUsers] = useState<any>(initalFilter);
  const [filterLocations, setFilterLocations] = useState<any>(initalFilter);
  const [filterFloorPlan, setFilterFloorPlan] = useState<any>(initalFilter);
  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState("");
  const [base64Image, setBase64Image] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [errorsAccountant, setErrorsAccountant] = useState<any>({});
  const [showPopupAccount, setShowPopupAccount] = useState<boolean>(false);
  const [messageErr, setMessageErr] = useState<string>("");
  const [countries, setCountries] = useState<Country[]>([]);
  const [accountant, setAccountant] = useState<any>();
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [tab, setTab] = useState<string>("company");
  const [listBankDetails, setListBankDetails] = useState<{ data: any[]; count: number }>({ data: [], count: 0 });
  const [showBankModal, setShowBankModal] = useState(false);
  const [editingBankId, setEditingBankId] = useState<string | null>(null);
  const [bankFormValues, setBankFormValues] = useState<CompanyBankDetailPayload>({
    bankName: "",
    IBAN: "",
    SWIFT: "",
    accountNo: "",
    bankLocation: "",
  });
  const [bankFormErrors, setBankFormErrors] = useState<Record<string, string>>({});
  const companyLimits = useFieldLimits(coreFormLimits("company"));
  const bankLimits = useFieldLimits(coreFormLimits("company-bank-detail"));
  const serviceChargeLimits = useFieldLimits(coreFormLimits("service-charge"));
  const gratuityLimits = useFieldLimits(coreFormLimits("gratuity"));
  const chargeTypeOptions = [
    { id: 1, name: "Percentage" },
    { id: 2, name: "Fixed" },
  ];
  const [serviceChargeForm, setServiceChargeForm] = useState({
    chargeType: 1,
    value: "",
    enable: "yes",
    optional: "yes",
    taxable: "yes",
  });
  const [serviceChargeErrors, setServiceChargeErrors] = useState<Record<string, string>>({});
  // The one value input saves as percentageValue or fixedAmount, by charge type.
  const serviceChargeValueField = Number(serviceChargeForm.chargeType) === 2 ? "fixedAmount" : "percentageValue";
  const [serviceChargeValue, setServiceChargeValue] = useState("Percentage");
  const [isServiceChargeTypeOpen, setIsServiceChargeTypeOpen] = useState(false);
  const [listServiceCharge, setListServiceCharge] = useState<any[]>([]);
  const [serviceChargeTotal, setServiceChargeTotal] = useState(0);
  const [serviceChargeFilter, setServiceChargeFilter] = useState({ page: 1, limit: 10 });
  const [serviceChargeLoading, setServiceChargeLoading] = useState(false);
  // Closed by default: the tab opens on the list (or on its empty state, which
  // carries the only "Add service charge" affordance).
  const [showServiceChargeForm, setShowServiceChargeForm] = useState(false);
  const [editingServiceChargeId, setEditingServiceChargeId] = useState<string | null>(null);
  const [showDeleteServiceCharge, setShowDeleteServiceCharge] = useState(false);
  const [idDeleteServiceCharge, setIdDeleteServiceCharge] = useState<string>("");
  const [gratuityForm, setGratuityForm] = useState<GratuityFormState>(emptyGratuityForm);
  const [gratuityErrors, setGratuityErrors] = useState<Record<string, string>>({});
  const [listGratuity, setListGratuity] = useState<GratuityRecord[]>([]);
  const [gratuityTotal, setGratuityTotal] = useState(0);
  const [gratuityFilter, setGratuityFilter] = useState({ page: 1, limit: 10 });
  const [gratuityLoading, setGratuityLoading] = useState(false);
  const [showGratuityForm, setShowGratuityForm] = useState(false);
  const [editingGratuityId, setEditingGratuityId] = useState<string | null>(null);
  const [showDeleteGratuity, setShowDeleteGratuity] = useState(false);
  const [idDeleteGratuity, setIdDeleteGratuity] = useState<string>("");
  const [gratuityLocations, setGratuityLocations] = useState<{ id: string; name: string }[]>([]);
  const [gratuityTaxGroups, setGratuityTaxGroups] = useState<{ id: string; name: string }[]>([]);
  const [gratuityDropdownOpen, setGratuityDropdownOpen] = useState<Record<string, boolean>>({});
  const [gratuityDropdownText, setGratuityDropdownText] = useState<Record<string, string>>({});
  const gratuityScopeRef = useRef<HTMLDivElement>(null);
  const gratuityTaxGroupRef = useRef<HTMLDivElement>(null);
  const gratuityPromptModeRef = useRef<HTMLDivElement>(null);
  const gratuityPercentBaseRef = useRef<HTMLDivElement>(null);
  const gratuityDropdownRefs: Record<string, React.RefObject<HTMLDivElement>> = {
    gratuityScope: gratuityScopeRef,
    gratuityTaxGroup: gratuityTaxGroupRef,
    gratuityPromptMode: gratuityPromptModeRef,
    gratuityPercentBase: gratuityPercentBaseRef,
  };
  const openGratuityDropdown = (key: string) => setGratuityDropdownOpen((prev) => ({ ...prev, [key]: true }));
  const closeGratuityDropdown = (key: string) => setGratuityDropdownOpen((prev) => ({ ...prev, [key]: false }));
  useEffect(() => {
    // Only touch state while a gratuity dropdown is open, so ordinary clicks stay free.
    const handleClickOutside = (event: MouseEvent) => {
      setGratuityDropdownOpen((prev) => {
        let next = prev;
        for (const [key, ref] of Object.entries(gratuityDropdownRefs)) {
          if (prev[key] && ref.current && !ref.current.contains(event.target as Node)) {
            next = next === prev ? { ...prev } : next;
            next[key] = false;
          }
        }
        return next;
      });
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const companyId = localStorage.getItem("companyId") || "";
  const userId = localStorage.getItem("userId") || "";
  const dropdownCountryRef = useRef<HTMLDivElement>(null);
  const dropdownServiceChargeTypeRef = useRef<HTMLDivElement>(null);
  const countryListRef = useRef<HTMLDivElement>(null);
  const [countryHighlight, setCountryHighlight] = useState(-1);
  const kb = useFormKeyboard();
  const inviteKb = useFormKeyboard();
  const bankKb = useFormKeyboard();
  const inviteDialogRef = useRef<HTMLDivElement>(null);
  const billingDialogRef = useRef<HTMLDivElement>(null);
  const bankDialogRef = useRef<HTMLDivElement>(null);
  const deleteServiceChargeDialogRef = useRef<HTMLDivElement>(null);
  const deleteGratuityDialogRef = useRef<HTMLDivElement>(null);
  const deleteDialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownCountryRef.current &&
        !dropdownCountryRef.current.contains(event.target as Node)
      ) {
        setIsCountryDropdownOpen(false);
      }
      if (
        dropdownServiceChargeTypeRef.current &&
        !dropdownServiceChargeTypeRef.current.contains(event.target as Node)
      ) {
        setIsServiceChargeTypeOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
    if (window.modulesContext) {
      const groups = window.modulesContext.modulesContext || [];
      const companyGroup = groups.find((v: any) => v.name === "Company");
      const companyPerms = (companyGroup?.value || []).filter(
        (v: any) =>
          v.name === "Billing" ||
          v.name === "Users" ||
          v.name === "Invoice configurations",
      );
      setListPermission(companyPerms);
    }
  }, [window, window.languageContext, window.modulesContext]);
  useEffect(() => {
    if (showPopupAccount) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopupAccount]);
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  const getListLocations = async (val: any) => {
    setLoading(true);
    webLoadingFalse();
    try {
      const response: any = await getLocations(
        userId,
        companyId,
        val.page,
        val.limit,
        val.searchValue,
      );
      let tempArray: any[] = [];
      response.data.data.forEach((each: any) => {
        tempArray.push({
          id: each.id,
          Code: each.locationCode,
          Name: each.name,
          Email: each.email,
          Status: each.isActive ? "Active" : "Not Active",
        });
      });
      setListLocation({ count: response.data.count, data: tempArray });
    } catch (error) {
      console.error("Error loading floor plans:", error);
    } finally {
      setLoading(false);
    }
  };
  const getAllFloorPlans = async (val: any) => {
    setLoading(true);
    webLoadingFalse();
    try {
      const response: any = await getListFloorPlan(
        val.page,
        val.limit,
        val.searchValue,
        localStorage.getItem("locationId") || "",
      );
      let tempArray: any[] = [];
      response.data.data.data.forEach((each: any) => {
        tempArray.push({
          id: each.id,
          "Plan Name": each.planName,
          Position: each.position,
          Description: each?.description || "/",
          Status: each.isActive ? "Active" : "Not Active",
        });
      });
      setListFloorPlan({ count: response.data.data.count, data: tempArray });
    } catch (error) {
      console.error("Error loading floor plans:", error);
    } finally {
      setLoading(false);
    }
  };
  const getListUser = async (val: any) => {
    setLoading(true);
    webLoadingFalse();
    try {
      const response: any = await getUser(companyId, val.page, val.limit);
      let tempArray: any[] = [];
      response.data.data.forEach((each: any) => {
        tempArray.push({
          id: each.userId,
          Code: each?.user?.userCode ?? "/",
          Name: each?.user?.lastName ?? "/",
          Email: each?.user?.emailAddress,
          Role: each?.userRole?.roleName,
          Status: each.isActive ? "Active" : "Not Active",
        });
      });
      setListUser({ count: response.data.count, data: tempArray });
    } catch (error) {
      console.error("Error loading floor plans:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchDetailCompany = async () => {
    const data: any = await getDetailCompanies(companyId);
    setFormValues(data?.data?.company);
    setAccountant(data?.data?.user);
    setSearchCountry(data?.data?.company?.country?.countryName);
  };
  useEffect(() => {
    const fetchCountries = async () => {
      const data = await getCountries();
      setCountries(data);
    };
    fetchCountries();
    fetchDetailCompany();
    const handleNewToken = async () => {
      const data = await getCountries();
      setCountries(data);
      fetchDetailCompany();
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, []);
  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleInviteChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValuesInvite({ ...formValuesInvite, [name]: value });
  };
  const handleCountrySelect = (countryId: string, countryName: string) => {
    setFormValues((prev: any) => ({ ...prev, countryId: countryId }));
    setSearchCountry(countryName);
    setIsCountryDropdownOpen(false);
  };
  const visibleCountries = isCountryDropdownOpen
    ? countries.filter((country) =>
      country.name
        .toLowerCase()
        .includes(
          searchCountry.toLowerCase(),
        ),
    )
    : [];
  // Enter saves only when the text names the selected country; otherwise it picks
  // (highlight, exact name, lone prefix match) or keeps the list open.
  const handleCountryKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      if (!isCountryDropdownOpen) {
        setCountryHighlight(-1);
        setIsCountryDropdownOpen(true);
        return;
      }
      if (visibleCountries.length === 0) return;
      const next = e.key === "ArrowDown"
        ? Math.min(countryHighlight + 1, visibleCountries.length - 1)
        : Math.max(countryHighlight - 1, 0);
      setCountryHighlight(next);
      (countryListRef.current?.children[next] as HTMLElement | undefined)?.scrollIntoView({ block: "nearest" });
      return;
    }
    if (e.key === "Enter" && !e.ctrlKey && !e.metaKey) {
      const typed = (searchCountry ?? "").trim().toLowerCase();
      const selectedName = countries.find((country) => country.id === formValues?.countryId)?.name ?? formValues?.country?.countryName ?? "";
      if (!isCountryDropdownOpen && typed === selectedName.trim().toLowerCase()) return;
      e.preventDefault();
      const lone = visibleCountries.length === 1 && visibleCountries[0].name.toLowerCase().startsWith(typed) ? visibleCountries[0] : undefined;
      const pick = visibleCountries[countryHighlight] ?? countries.find((country) => country.name.trim().toLowerCase() === typed) ?? lone;
      if (pick) handleCountrySelect(pick.id, pick.name);
      else {
        setCountryHighlight(-1);
        setIsCountryDropdownOpen(true);
      }
      return;
    }
    if (isCountryDropdownOpen && (e.key === "Escape" || e.key === "Tab")) {
      const typed = (searchCountry ?? "").trim().toLowerCase();
      const pick = visibleCountries[countryHighlight] ?? countries.find((country) => country.name.trim().toLowerCase() === typed);
      if (e.key === "Escape") e.preventDefault();
      if (e.key === "Tab" && pick) handleCountrySelect(pick.id, pick.name);
      else setIsCountryDropdownOpen(false);
      return;
    }
    validateNoSpecialChars(e);
  };
  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        setFileName(file.name);
        setBase64Image(base64Image);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please upload an image file.");
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = reader.result as string;
        setFileName(file.name);
        setBase64Image(base64);
      };

      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid image file.");
    }
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits(formValues ?? {}, companyLimits, language);
    // Company number, fiscal number, tax code, address line 1/2, postal code and
    // web URL are optional on the company-details form. Only invoice prefix is
    // required.
    if (!formValues.invoicePrefix) {
      newErrors.invoicePrefix = "Invoice Prefix is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    webLoadingTrue();
    if (tab === "company") {
      const payload: any = { ...formValues, companyLogo: base64Image };
      try {
        const response = await updateDetialCompanies(companyId, payload);
        if (response?.data?.id) {
          webLoadingFalse();
          setErrors({});
          setShowPopup(true);
          setMessageErr("Update successfully");
        }
      } catch (error: any) {
        webLoadingFalse();
        setShowPopup(true);
        setMessageErr(showApiError(error, { language, setFieldErrors: setErrors }).message);
      }
    }
  };

  const handleSaveInvoiceConfig = async (e: React.MouseEvent) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits(formValues ?? {}, companyLimits, language, ["invoicePrefix"]);
    if (!formValues.invoicePrefix || !String(formValues.invoicePrefix).trim()) {
      newErrors.invoicePrefix = language?.["Invoice Prefix is required"] ?? "Invoice Prefix is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    webLoadingTrue();
    try {
      const payload: any = { ...formValues, companyLogo: base64Image };
      const response = await updateDetialCompanies(companyId, payload);
      if (response?.data?.id) {
        webLoadingFalse();
        setErrors({});
        setShowPopup(true);
        setMessageErr(language?.["Update successfully"] ?? "Update successfully");
      }
    } catch (error: any) {
      webLoadingFalse();
      setShowPopup(true);
      setMessageErr(
        showApiError(error, {
          language,
          titleFallback: language?.["Error updating invoice configuration"] ?? "Error updating invoice configuration",
          setFieldErrors: setErrors,
        }).message,
      );
    }
  };

  const resetServiceChargeForm = () => {
    setServiceChargeForm({
      chargeType: 1,
      value: "",
      enable: "yes",
      optional: "yes",
      taxable: "yes",
    });
    setServiceChargeValue("Percentage");
    setEditingServiceChargeId(null);
    setServiceChargeErrors({});
  };

  const normalizeServiceCharge = (item: any) => {
    const typeRaw = item?.chargeType ?? item?.chargeTypeId ?? item?.type ?? 1;
    const chargeType = Number(typeRaw) === 2 ? 2 : 1;
    const percentageValue = item?.percentageValue;
    const fixedAmount = item?.fixedAmount;
    const fallbackValue = item?.value ?? item?.amount ?? item?.chargeValue ?? 0;
    const valueByType = chargeType === 1
      ? (percentageValue ?? fallbackValue)
      : (fixedAmount ?? fallbackValue);
    return {
      id: item?.id ?? item?._id ?? "",
      chargeType,
      chargeTypeText: chargeType === 2 ? "Fixed" : "Percentage",
      value: valueByType ?? 0,
      isEnabled: Boolean(item?.isEnabled ?? item?.enabled ?? item?.enable ?? false),
      isOptional: Boolean(item?.isOptional ?? item?.optional ?? false),
      isTaxable: Boolean(item?.isTaxable ?? item?.taxable ?? false),
    };
  };

  const getDataServiceCharge = async (page: number = serviceChargeFilter.page) => {
    setServiceChargeLoading(true);
    try {
      const response = await getServiceChargeList(page, serviceChargeFilter.limit, "");
      const rawData =
        response?.data?.serviceChargeSettings ??
        response?.serviceChargeSettings ??
        response?.data?.data ??
        response?.data ??
        response ??
        [];
      const total =
        response?.data?.total ??
        response?.total ??
        (Array.isArray(rawData) ? rawData.length : 0);
      const list = Array.isArray(rawData) ? rawData : [];
      const normalized = list.filter(Boolean).map(normalizeServiceCharge).filter((v) => v.id);
      setListServiceCharge(normalized);
      setServiceChargeTotal(total);
      setServiceChargeFilter((prev) => ({ ...prev, page }));
      // Always land on the list: with a charge it shows the row to edit,
      // without one it shows the empty state that offers "Add service charge".
      setShowServiceChargeForm(false);
      if (normalized.length === 0) resetServiceChargeForm();
    } catch (error: any) {
      // A failed load is not an empty company. Clearing the list here would
      // render "No service charge yet" with an Add button over a charge the
      // server may well have — and that create then 409s. Say the load failed
      // and keep whatever the list already held.
      showApiError(error, {
        language,
        titleFallback: language?.["Error loading service charges"] ?? "Error loading service charges",
      });
      setShowServiceChargeForm(false);
    } finally {
      setServiceChargeLoading(false);
    }
  };

  /** A company may hold at most one service charge; the Add affordance is hidden once one exists. */
  const handleAddServiceCharge = () => {
    if (listServiceCharge.length > 0) {
      // Only reachable if the list changed between paint and tap — say why
      // nothing opened rather than ignoring the tap.
      showToast({
        message:
          language?.["This company already has a service charge. Edit or remove the existing one."] ??
          "This company already has a service charge. Edit or remove the existing one.",
        type: "error",
        duration: 10000,
      });
      return;
    }
    resetServiceChargeForm();
    setShowServiceChargeForm(true);
  };

  const handleBackServiceCharge = () => {
    setShowServiceChargeForm(false);
    setEditingServiceChargeId(null);
    resetServiceChargeForm();
  };

  const totalServiceChargePages = Math.max(1, Math.ceil((serviceChargeTotal || 0) / serviceChargeFilter.limit));

  const getServiceChargeVisiblePages = (): (number | string)[] => {
    const pages: (number | string)[] = [];
    if (totalServiceChargePages <= 7) {
      for (let i = 1; i <= totalServiceChargePages; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    if (serviceChargeFilter.page <= 3) {
      pages.push(2, 3, "...", totalServiceChargePages);
    } else if (serviceChargeFilter.page >= totalServiceChargePages - 2) {
      pages.push("...", totalServiceChargePages - 2, totalServiceChargePages - 1, totalServiceChargePages);
    } else {
      pages.push("...", serviceChargeFilter.page - 1, serviceChargeFilter.page, serviceChargeFilter.page + 1, "...", totalServiceChargePages);
    }
    return pages;
  };

  const handleServiceChargePageClick = (page: number | string) => {
    if (typeof page !== "number" || page === serviceChargeFilter.page) return;
    getDataServiceCharge(page);
  };

  const serviceChargePaginationContainerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontFamily: "Inter, system-ui, sans-serif",
  };

  const serviceChargePaginationTextStyle: React.CSSProperties = {
    fontSize: "14px",
    color: "#4A5353",
    fontWeight: "500",
    fontFamily: "inter",
  };

  const serviceChargePaginationWrapperStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    border: "1px solid #EBF0F0",
    borderRadius: "36px",
    padding: "8px 16px",
  };

  const serviceChargeButtonBaseStyle: React.CSSProperties = {
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    borderRadius: "24px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s",
    backgroundColor: "transparent",
  };

  const getServiceChargeButtonStyle = (page: number | string, isActive: boolean): React.CSSProperties => {
    if (page === "...") {
      return {
        ...serviceChargeButtonBaseStyle,
        cursor: "default",
        color: "#6A7878",
      };
    }
    if (isActive) {
      return {
        ...serviceChargeButtonBaseStyle,
        backgroundColor: "#DBE4E4",
        color: "#0D5759",
        fontWeight: "500",
      };
    }
    return {
      ...serviceChargeButtonBaseStyle,
      color: "#374151",
    };
  };

  const serviceChargeArrowButtonStyle = (disabled: boolean): React.CSSProperties => ({
    ...serviceChargeButtonBaseStyle,
    color: disabled ? "#B5C6C7" : "#6A7878",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
  });

  const ChevronLeftIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" pointerEvents="none">
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );

  const ChevronRightIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" pointerEvents="none">
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );

  /**
   * The row this tab is showing may already be gone (deleted in another tab or
   * by another user): say so, drop the phantom row from the list, and leave the
   * user on a list that matches the server instead of a dead affordance.
   */
  const reportServiceChargeGone = async () => {
    showToast({
      message:
        language?.["This service charge no longer exists. It may have been removed."] ??
        "This service charge no longer exists. It may have been removed.",
      type: "error",
      duration: 10000,
    });
    await getDataServiceCharge(1);
  };

  // Resolves true once the record is in the form (mobile opens its sheet only then).
  const handleEditServiceCharge = async (id: string): Promise<boolean> => {
    webLoadingTrue();
    try {
      const response = await getServiceChargeById(id);
      const detailSource =
        response?.data?.serviceChargeSetting ??
        response?.serviceChargeSetting ??
        response?.data?.data ??
        response?.data ??
        response;
      const detail = normalizeServiceCharge(detailSource);
      // get-one answers 200 with an empty body for a row that is gone, so an
      // id-less detail is the delete-in-another-tab case, not a transport error.
      if (!detail.id) {
        await reportServiceChargeGone();
        return false;
      }
      setEditingServiceChargeId(detail.id);
      setServiceChargeForm({
        chargeType: detail.chargeType,
        value: String(detail.value ?? ""),
        enable: detail.isEnabled ? "yes" : "no",
        optional: detail.isOptional ? "yes" : "no",
        taxable: detail.isTaxable ? "yes" : "no",
      });
      setServiceChargeValue(detail.chargeTypeText);
      setServiceChargeErrors({});
      setShowServiceChargeForm(true);
      return true;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        await reportServiceChargeGone();
        return false;
      }
      showApiError(error, {
        language,
        titleFallback: language?.["Error loading service charge"] ?? "Error loading service charge",
      });
      return false;
    } finally {
      webLoadingFalse();
    }
  };

  const handleShowDeleteServiceCharge = (id: string) => {
    setIdDeleteServiceCharge(id);
    setShowDeleteServiceCharge(true);
  };

  const handleDeleteServiceCharge = async () => {
    if (!idDeleteServiceCharge) return;
    try {
      await deleteServiceCharge(idDeleteServiceCharge);
      showToast({
        message: language?.["Service charge deleted successfully"] ?? "Service charge deleted successfully",
        type: "success",
        duration: 5000,
      });
      setShowDeleteServiceCharge(false);
      setIdDeleteServiceCharge("");
      await getDataServiceCharge();
    } catch (error: any) {
      // Close the confirm first: leaving it open over a failed delete gives the
      // user nothing to do but press Delete again. The refetch below either
      // brings the row back or drops it if it was already gone (404).
      setShowDeleteServiceCharge(false);
      setIdDeleteServiceCharge("");
      if (error?.response?.status === 404) {
        await reportServiceChargeGone();
        return;
      }
      showApiError(error, {
        language,
        titleFallback: language?.["Error deleting service charge"] ?? "Error deleting service charge",
      });
      await getDataServiceCharge();
    }
  };

  const handleSaveServiceCharge = async (e: React.MouseEvent) => {
    e.preventDefault();
    const valueNumber = Number(serviceChargeForm.value);
    if (serviceChargeForm.value === "" || Number.isNaN(valueNumber)) {
      showToast({
        message: language?.["Value is required"] ?? "Value is required",
        type: "error",
        duration: 5000,
      });
      return;
    }
    const limitError = validateAgainstLimits({ [serviceChargeValueField]: valueNumber }, serviceChargeLimits, language, [
      serviceChargeValueField,
    ])[serviceChargeValueField];
    setServiceChargeErrors(limitError ? { value: limitError } : {});
    if (limitError) return;
    const payload = {
      chargeType: Number(serviceChargeForm.chargeType),
      enabled: serviceChargeForm.enable === "yes",
      optional: serviceChargeForm.optional === "yes",
      taxable: serviceChargeForm.taxable === "yes",
      percentageValue: Number(serviceChargeForm.chargeType) === 1 ? valueNumber : null,
      fixedAmount: Number(serviceChargeForm.chargeType) === 2 ? valueNumber : null,
    };
    webLoadingTrue();
    try {
      if (editingServiceChargeId) {
        await updateServiceCharge(editingServiceChargeId, payload as any);
        showToast({
          message: language?.["Service charge updated successfully"] ?? "Service charge updated successfully",
          type: "success",
          duration: 5000,
        });
      } else {
        await createServiceCharge(payload as any);
        showToast({
          message: language?.["Service charge created successfully"] ?? "Service charge created successfully",
          type: "success",
          duration: 5000,
        });
      }
      await getDataServiceCharge(1);
      setShowServiceChargeForm(false);
      setEditingServiceChargeId(null);
    } catch (error: any) {
      // The one-per-company rule is enforced by the API as well. A tab that was
      // opened before someone else added the charge can still reach create and
      // get a 409: show what the server said and resync onto the list.
      if (!editingServiceChargeId && error?.response?.status === 409) {
        showApiError(error, { language });
        await getDataServiceCharge(1);
        setShowServiceChargeForm(false);
        setEditingServiceChargeId(null);
        return;
      }
      showApiError(error, {
        language,
        titleFallback: language?.["Error saving service charge"] ?? "Error saving service charge",
        setFieldErrors: setServiceChargeErrors,
        fieldAliases: { percentageValue: "value", fixedAmount: "value" },
      });
    } finally {
      webLoadingFalse();
    }
  };

  /* ---------------- Gratuity ---------------- */

  const tr = (key: string): string => language?.[key] ?? key;

  const gratuityScopeOptions = [{ id: "", name: tr("Company default") }, ...gratuityLocations];

  const gratuityScopeName = (item: { locationId: string | null; locationName?: string }) =>
    item.locationId
      ? item.locationName || gratuityLocations.find((l) => l.id === item.locationId)?.name || tr("Location")
      : tr("Company default");

  const syncGratuityDropdownText = (form: GratuityFormState, record?: GratuityRecord) =>
    setGratuityDropdownText({
      gratuityScope: form.locationId
        ? record?.locationName || gratuityLocations.find((l) => l.id === form.locationId)?.name || ""
        : tr("Company default"),
      gratuityTaxGroup: record?.taxGroupName || gratuityTaxGroups.find((g) => g.id === form.taxGroupId)?.name || "",
      gratuityPromptMode: tr(labelOf(GRATUITY_PROMPT_MODES, form.promptMode)),
      gratuityPercentBase: tr(labelOf(GRATUITY_PERCENT_BASES, form.percentBase)),
    });

  const getDataGratuity = async (page: number = gratuityFilter.page) => {
    setGratuityLoading(true);
    try {
      const response = await getGratuitySettingList(page, gratuityFilter.limit);
      const inner = response?.data ?? response;
      const raw = inner?.gratuitySettings ?? [];
      const list = Array.isArray(raw) ? raw : [];
      const normalized = list.filter(Boolean).map(normalizeGratuity).filter((v) => v.id);
      const total = inner?.total ?? normalized.length;
      // Deleting the last row of the last page lands on the new last page, not on a false empty state.
      const lastPage = Math.max(1, Math.ceil(total / gratuityFilter.limit));
      if (normalized.length === 0 && page > lastPage) return getDataGratuity(lastPage);
      setListGratuity(normalized);
      setGratuityTotal(total);
      setGratuityFilter((prev) => ({ ...prev, page }));
      setShowGratuityForm(false);
    } catch (error: any) {
      // A failed load is not an empty company: keep what the list held and say so.
      showApiError(error, { language, titleFallback: tr("Error loading gratuity settings") });
      setShowGratuityForm(false);
    } finally {
      setGratuityLoading(false);
    }
  };

  // The scope and tax-group pickers need the whole lists, not the paged tab data.
  const loadGratuityPickers = async () => {
    try {
      const [locations, taxGroups] = await Promise.all([
        getLocations(userId, companyId, 1, 100, ""),
        getGroupTax({ page: 1, limit: 100, searchValue: "", sort: "ASC" }),
      ]);
      const locationRows = locations?.data?.data;
      setGratuityLocations(
        (Array.isArray(locationRows) ? locationRows : []).map((l: any) => ({ id: l.id, name: l.name ?? "" })),
      );
      const groupRows = taxGroups?.data;
      setGratuityTaxGroups(
        (Array.isArray(groupRows) ? groupRows : []).map((g: any) => ({ id: g.id, name: g.groupName ?? g.name ?? "" })),
      );
    } catch (error) {
      console.error("Error loading gratuity pickers:", error);
    }
  };

  const handleAddGratuity = () => {
    const form = emptyGratuityForm();
    // The first setting is the company default; later ones offer the first location without one.
    // Only when the page holds every row, else the guess could name a scope that is already taken.
    if (gratuityTotal <= gratuityFilter.limit && listGratuity.some((item) => !item.locationId)) {
      const free = gratuityLocations.find((l) => !listGratuity.some((item) => item.locationId === l.id));
      form.locationId = free?.id ?? "";
    }
    setEditingGratuityId(null);
    setGratuityForm(form);
    setGratuityErrors({});
    syncGratuityDropdownText(form);
    setShowGratuityForm(true);
  };

  const handleBackGratuity = () => {
    setShowGratuityForm(false);
    setEditingGratuityId(null);
    setGratuityForm(emptyGratuityForm());
    setGratuityErrors({});
  };

  const totalGratuityPages = Math.max(1, Math.ceil((gratuityTotal || 0) / gratuityFilter.limit));

  const handleGratuityPageClick = (page: number | string) => {
    if (typeof page !== "number" || page < 1 || page > totalGratuityPages || page === gratuityFilter.page) return;
    getDataGratuity(page);
  };

  const reportGratuityGone = async () => {
    showToast({
      message: tr("These gratuity settings no longer exist. They may have been removed."),
      type: "error",
      duration: 10000,
    });
    await getDataGratuity(1);
  };

  // Resolves true once the record is in the form (mobile opens its sheet only then).
  const handleEditGratuity = async (id: string): Promise<boolean> => {
    webLoadingTrue();
    try {
      const response = await getGratuitySettingById(id);
      // get-one answers 200 with data null for a row that is gone.
      const detail = normalizeGratuity(response?.data ?? null);
      if (!detail.id) {
        await reportGratuityGone();
        return false;
      }
      const form = gratuityFormFromRecord(detail);
      setEditingGratuityId(detail.id);
      setGratuityForm(form);
      setGratuityErrors({});
      syncGratuityDropdownText(form, detail);
      setShowGratuityForm(true);
      return true;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        await reportGratuityGone();
        return false;
      }
      showApiError(error, { language, titleFallback: tr("Error loading gratuity settings") });
      return false;
    } finally {
      webLoadingFalse();
    }
  };

  const handleShowDeleteGratuity = (id: string) => {
    setIdDeleteGratuity(id);
    setShowDeleteGratuity(true);
  };

  const handleDeleteGratuity = async () => {
    if (!idDeleteGratuity) return;
    try {
      await deleteGratuitySetting(idDeleteGratuity);
      showToast({
        message: tr("Gratuity settings deleted successfully"),
        type: "success",
        duration: 5000,
      });
      setShowDeleteGratuity(false);
      setIdDeleteGratuity("");
      await getDataGratuity();
    } catch (error: any) {
      // Close the confirm first; the refetch brings the row back or drops it if it was already gone.
      setShowDeleteGratuity(false);
      setIdDeleteGratuity("");
      if (error?.response?.status === 404) {
        await reportGratuityGone();
        return;
      }
      showApiError(error, { language, titleFallback: tr("Error deleting gratuity settings") });
      await getDataGratuity();
    }
  };

  const handleSaveGratuity = async (e: React.MouseEvent) => {
    e.preventDefault();
    const payload = gratuityPayloadFromForm(gratuityForm);
    const limitErrors = validateAgainstLimits({ ...payload }, gratuityLimits, language);
    setGratuityErrors(limitErrors);
    if (Object.keys(limitErrors).length > 0) return;
    const problem = gratuityFormProblem(gratuityForm);
    if (problem) {
      showToast({ message: tr(problem), type: "error", duration: 5000 });
      return;
    }
    webLoadingTrue();
    try {
      if (editingGratuityId) {
        await updateGratuitySetting(editingGratuityId, payload);
        showToast({ message: tr("Gratuity settings updated successfully"), type: "success", duration: 5000 });
      } else {
        await createGratuitySetting(payload);
        showToast({ message: tr("Gratuity settings created successfully"), type: "success", duration: 5000 });
      }
      await getDataGratuity(1);
      setShowGratuityForm(false);
      setEditingGratuityId(null);
    } catch (error: any) {
      if (editingGratuityId && error?.response?.status === 404) {
        await reportGratuityGone();
        setShowGratuityForm(false);
        setEditingGratuityId(null);
        return;
      }
      // One row per scope is enforced by the API too (409); the form stays open so the scope can change.
      showApiError(error, {
        language,
        titleFallback: tr("Error saving gratuity settings"),
        setFieldErrors: setGratuityErrors,
      });
    } finally {
      webLoadingFalse();
    }
  };

  const gratuityRadioStyle = (checked: boolean): React.CSSProperties => ({
    width: 20,
    height: 20,
    minWidth: 20,
    minHeight: 20,
    margin: 0,
    flexShrink: 0,
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    borderRadius: "50%",
    border: checked ? "1px solid #0F7679" : "1px solid #C9D7D8",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    backgroundImage: checked ? "radial-gradient(circle at center, #0F7679 0, #0F7679 5px, #ffffff 5.5px)" : "none",
  });

  const renderGratuityYesNo = (key: GratuityYesNoKey, label: string) => (
    <div style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
      <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500", marginBottom: "8px" }}>
        {label}
      </p>
      <div className="flex items-center" style={{ gap: "16px", height: "48px" }}>
        {(["yes", "no"] as const).map((choice) => (
          <label key={choice} className="flex items-center font-inter text-[14px]" style={{ gap: "8px", color: "#4A5353", cursor: "pointer" }}>
            <input
              type="radio"
              name={`gratuity-${key}`}
              checked={gratuityForm[key] === choice}
              onChange={() => setGratuityForm((prev) => ({ ...prev, [key]: choice }))}
              style={gratuityRadioStyle(gratuityForm[key] === choice)}
            />
            {choice === "yes" ? tr("Yes") : tr("No")}
          </label>
        ))}
      </div>
    </div>
  );

  const gratuityIconButtonStyle = (disabled: boolean): React.CSSProperties => ({
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #EBF0F0",
    borderRadius: "8px",
    background: "transparent",
    color: disabled ? "#B5C6C7" : "#4A5353",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: "14px",
    padding: 0,
  });

  const gratuityInputClass =
    "text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full";

  const openBankModal = (item?: any) => {
    if (item) {
      setEditingBankId(item.id);
      setBankFormValues({
        bankName: item.bankName ?? "",
        IBAN: item.IBAN ?? "",
        SWIFT: item.SWIFT ?? "",
        accountNo: item.accountNo ?? "",
        bankLocation: item.bankLocation ?? "",
      });
    } else {
      setEditingBankId(null);
      setBankFormValues({
        bankName: "",
        IBAN: "",
        SWIFT: "",
        accountNo: "",
        bankLocation: "",
      });
    }
    setBankFormErrors({});
    setShowBankModal(true);
  };

  const closeBankModal = () => {
    setShowBankModal(false);
    setEditingBankId(null);
    setBankFormValues({ bankName: "", IBAN: "", SWIFT: "", accountNo: "", bankLocation: "" });
    setBankFormErrors({});
  };

  const handleBankFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBankFormValues((prev) => ({ ...prev, [name]: value }));
    if (bankFormErrors[name]) setBankFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveBankDetail = async () => {
    const err: Record<string, string> = validateAgainstLimits({ ...bankFormValues }, bankLimits, language);
    if (!bankFormValues.bankName?.trim()) {
      err.bankName = language?.["Bank name is required"] ?? "Bank name is required";
    }
    setBankFormErrors(err);
    if (Object.keys(err).length > 0) return;
    webLoadingTrue();
    try {
      const payload: CompanyBankDetailPayload = {
        bankName: bankFormValues.bankName.trim(),
        IBAN: bankFormValues.IBAN?.trim() || undefined,
        SWIFT: bankFormValues.SWIFT?.trim() || undefined,
        accountNo: bankFormValues.accountNo?.trim() || undefined,
        bankLocation: bankFormValues.bankLocation?.trim() || undefined,
      };
      if (editingBankId) {
        await updateCompanyBankDetail(editingBankId, payload);
        setShowPopup(true);
        setMessageErr(language?.["Bank detail updated successfully"] ?? "Bank detail updated successfully");
      } else {
        await createCompanyBankDetail(payload);
        setShowPopup(true);
        setMessageErr(language?.["Bank detail created successfully"] ?? "Bank detail created successfully");
      }
      closeBankModal();
      fetchBankDetails();
    } catch (error: any) {
      setShowPopup(true);
      setMessageErr(
        showApiError(error, {
          language,
          titleFallback: language?.["Error saving bank detail"] ?? "Error saving bank detail",
          setFieldErrors: setBankFormErrors,
        }).message,
      );
    } finally {
      webLoadingFalse();
    }
  };

  const handleDeleteBankDetail = async (id: string) => {
    webLoadingTrue();
    try {
      await deleteCompanyBankDetail(id);
      setShowPopup(true);
      setMessageErr(language?.["Bank detail deleted successfully"] ?? "Bank detail deleted successfully");
      fetchBankDetails();
    } catch (error: any) {
      setShowPopup(true);
      // The result popup is this action's only error surface, so it gets the friendly text, not a toast too.
      setMessageErr(describeApiError(error, { language, locale }).message);
    } finally {
      webLoadingFalse();
    }
  };

  const handleReceivePageNumberBilling = (pageNumber: number) => {
    const updatedFilter = {
      ...filterBilling,
      page: pageNumber,
      limit: filterBilling.limit || 50,
    };
    const url = updateUrlParams(updatedFilter);
    webNavigate(url);
    setFilterBilling(updatedFilter);
    getListLocations(updatedFilter);
  };

  const handleReceivePageNumberUsers = (pageNumber: number) => {
    const updatedFilter = {
      ...filterUsers,
      page: pageNumber,
      limit: filterUsers.limit || 50,
    };
    const url = updateUrlParams(updatedFilter);
    webNavigate(url);
    setFilterUsers(updatedFilter);
    getListUser(updatedFilter);
  };

  const handleReceivePageNumberLocations = (pageNumber: number) => {
    const updatedFilter = {
      ...filterLocations,
      page: pageNumber,
      limit: filterLocations.limit || 50,
    };
    const url = updateUrlParams(updatedFilter);
    webNavigate(url);
    setFilterLocations(updatedFilter);
    getListLocations(updatedFilter);
  };

  const handleReceivePageNumberFloorPlan = (pageNumber: number) => {
    const updatedFilter = {
      ...filterFloorPlan,
      page: pageNumber,
      limit: filterFloorPlan.limit || 50,
    };
    const url = updateUrlParams(updatedFilter);
    webNavigate(url);
    setFilterFloorPlan(updatedFilter);
    getAllFloorPlans(updatedFilter);
  };

  const handleShowDelete = (id: string) => {
    setShowDelete(true);
    setIdDelete(id);
  };

  const handleRemove = async (v: any) => {
    webLoadingTrue();
    const payload: any = {
      companyAdminId: userId,
      userId: v.userId,
      companyId: companyId,
    };
    try {
      const response = await removeInviteAccountant(payload);
      if (response.data.success) {
        setErrorsAccountant({});
        setShowPopupAccount(false);
        webLoadingFalse();
        setShowPopup(true);
        setMessageErr("Remove successfully");
      }
    } catch (error: any) {
      console.log("🚀 ~ handleSendInvite ~ error:", error);
      webLoadingFalse();
      setShowPopup(true);
      setShowPopupAccount(false);
      setMessageErr(showApiError(error, { language }).message);
    } finally {
      fetchDetailCompany();
    }
  };

  const handleSendInvite = async () => {
    const newErrors: any = {};
    if (!formValuesInvite.firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!formValuesInvite.lastName) {
      newErrors.lastName = "Last Name is required";
    }
    if (!formValuesInvite.emailAddress) {
      newErrors.emailAddress = "Email Address is required";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrorsAccountant(newErrors);
      return;
    }
    webLoadingTrue();
    const payload: any = {
      userId: userId,
      companyId: companyId,
      emailAddress: formValuesInvite.emailAddress,
    };
    try {
      const response = await sentInviteAccountant(payload);
      if (response.data.success) {
        setErrorsAccountant({});
        setShowPopupAccount(false);
        fetchDetailCompany();
        webLoadingFalse();
        showToast({
          message: "Invite sent successfully",
          type: "success",
          duration: 20000,
        });
      }
    } catch (error: any) {
      console.log("🚀 ~ handleSendInvite ~ error:", error);
      webLoadingFalse();
      const fe = showApiError(error, { language, setFieldErrors: setErrorsAccountant });
      if (!fe.fieldErrors) setShowPopupAccount(false);
    }
  };
  // The side tabs are <p> menu items: make them reachable and pressable from the keyboard.
  const sideTabProps = (name: string) => ({
    role: "tab",
    "aria-selected": tab === name,
    tabIndex: 0,
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        // Not on a held key, nor on the open tab (it would reset and refetch its list).
        if (e.repeat || name === tab) return;
        handleChangeTab(name);
      }
    },
  });
  const handleChangeTab = (value: string) => {
    setTab(value);
    let updatedFilter;
    switch (value) {
      case "user":
        updatedFilter = {
          ...filterUsers,
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        setFilterUsers(updatedFilter);
        getListUser(updatedFilter);
        break;
      case "location":
        updatedFilter = {
          ...filterLocations,
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        setFilterLocations(updatedFilter);
        getListLocations(updatedFilter);
        break;

      case "billing":
        updatedFilter = {
          ...filterBilling,
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        setFilterBilling(updatedFilter);
        // getListBilling(updatedFilter);
        break;
      case "invoice":
        updatedFilter = {
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        // setFilterBilling(updatedFilter);
        // getListBilling(updatedFilter);
        break;
      case "serviceCharge":
        updatedFilter = {
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        break;
      case "gratuity":
        updatedFilter = {
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        break;
      case "floorPlan":
        updatedFilter = {
          ...filterFloorPlan,
          tab: value,
          page: 1,
          limit: 50,
          searchValue: "",
        };
        setFilterFloorPlan(updatedFilter);
        getAllFloorPlans(updatedFilter);
        break;
      case "company":
        updatedFilter = { tab: "company" };
        break;
      default:
        return;
    }

    const url = updateUrlParams(updatedFilter);
    webNavigate(url);
  };

  useEffect(() => {
    const filterParams: any = extractValues(location.search.split("&"));
    const groups = window.modulesContext.modulesContext || [];
    const companyGroup = groups.find((v: any) => v.name === "Company");
    const dataPermissions = (companyGroup?.value || []).filter(
      (v: any) =>
        v.name === "Billing" ||
        v.name === "Users" ||
        v.name === "Invoice configurations",
    );
    const TAB_PERMISSION_MAP: Record<string, string> = {
      billing: "Billing",
      user: "Users",
      invoice: "Invoice configurations",
      serviceCharge: "Invoice configurations",
      gratuity: "Invoice configurations",
    };
    const getValidTab = (tab: string): string => {
      const requiredPermission = TAB_PERMISSION_MAP[tab];
      if (!requiredPermission) return tab;

      const hasAccess = dataPermissions.some(
        (v: any) => v.name === requiredPermission && v.value === true
      );
      return hasAccess ? tab : "company";
    };
    const validTab = getValidTab(filterParams.tab);
    if (validTab !== filterParams.tab) {
      webNavigate(`${location.pathname}?tab=company`);
    }
    const defaultParams = {
      tab: validTab,
      searchValue: filterParams.search || "",
      page: +filterParams.page || 1,
      limit: +filterParams.limit || 50,
    };
    const updateFilter = (tab: string, data: any) => {
      const filterData = {
        ...data,
        tab: tab || data.tab,
        searchValue: data.searchValue || "",
        page: data.page || 1,
        limit: data.limit || 50,
      };

      if (tab === "user") {
        setFilterUsers(filterData);
        getListUser(filterData);
      } else if (tab === "location") {
        setFilterLocations(filterData);
        getListLocations(filterData);
      } else if (tab === "floorPlan") {
        getAllFloorPlans(filterData);
      }
    };
    setTab(defaultParams.tab ? defaultParams.tab : "company");
    updateFilter(defaultParams.tab, defaultParams);
    const handleNewToken = () => {
      updateFilter(defaultParams.tab, defaultParams);
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [location]);

  useEffect(() => {
    if (tab === "invoice") {
      fetchDetailCompany();
      fetchBankDetails();
    }
    if (tab === "serviceCharge") {
      getDataServiceCharge();
    }
    if (tab === "gratuity") {
      getDataGratuity();
      loadGratuityPickers();
    }
  }, [tab]);

  const fetchBankDetails = async () => {
    try {
      const res = await getCompanyBankDetailList(1, 100, "");
      const inner = res?.data ?? res;
      const list = Array.isArray(inner) ? inner : (inner?.data ?? []);
      const count = inner?.count ?? list?.length ?? 0;
      setListBankDetails({ data: list, count });
    } catch (err) {
      setListBankDetails({ data: [], count: 0 });
    }
  };

  const handleDeleteFloorPlan = async () => {
    try {
      const response = await deleteFloorPlan(idDelete);
    } catch (error) {
      console.error("Error loading floor plans:", error);
      showApiError(error, { language });
    } finally {
      getAllFloorPlans(initalFilter);
      setShowDelete(false);
    }
  };

  // The "Delete Item" confirm is opened from the Users and Locations lists;
  // delete the entity the open tab shows and refresh that list.
  const handleDeleteItem = async (which: string = tab, id: string = idDelete) => {
    if (!id) {
      // Nothing to delete (the Billing sample rows have no id): close the
      // confirm instead of leaving it open with a dead button.
      setShowDelete(false);
      return;
    }
    webLoadingTrue();
    try {
      if (which === "user") {
        await deleteUserCompany(companyId, id);
      } else if (which === "location") {
        await deleteLocations(id);
      } else {
        await deleteFloorPlan(id);
      }
      showToast({
        message: language?.["Deleted successfully"] ?? "Deleted successfully",
        type: "success",
        duration: 5000,
      });
    } catch (error: any) {
      console.error("Error deleting item:", error);
      showApiError(error, { language, titleFallback: language?.["Error deleting item"] ?? "Error deleting item" });
    } finally {
      webLoadingFalse();
      setShowDelete(false);
      setIdDelete("");
      if (which === "user") getListUser(filterUsers);
      else if (which === "location") getListLocations(filterLocations);
      else getAllFloorPlans(initalFilter);
    }
  };

  useDialogFocus(showPopupAccount, inviteDialogRef, () => {
    setShowPopupAccount(false);
    setErrorsAccountant({});
  });
  useDialogFocus(showPopupBilling, billingDialogRef, () => setShowPopupBilling(false));
  useDialogFocus(showBankModal, bankDialogRef, closeBankModal);
  useDialogFocus(showDeleteServiceCharge, deleteServiceChargeDialogRef, () => {
    setShowDeleteServiceCharge(false);
    setIdDeleteServiceCharge("");
  });
  useDialogFocus(showDeleteGratuity, deleteGratuityDialogRef, () => {
    setShowDeleteGratuity(false);
    setIdDeleteGratuity("");
  });
  useDialogFocus(showDelete, deleteDialogRef, () => setShowDelete(false));

  if (isMobile) {
    return (
      <>
        <CompanyMobile
          language={language}
          tab={tab}
          onChangeTab={handleChangeTab}
          permissions={{
            billing: !!listPermission?.find((v: any) => v.name === "Billing" && v.value),
            users: !!listPermission?.find((v: any) => v.name === "Users" && v.value),
            invoice: !!listPermission?.find((v: any) => v.name === "Invoice configurations" && v.value),
          }}
          loading={loading}
          formValues={formValues}
          setFormValues={setFormValues}
          handleChange={handleChange}
          errors={errors}
          setErrors={setErrors}
          onSubmitCompany={() => handleSubmit({ preventDefault() {} } as any)}
          onCancelCompany={fetchDetailCompany}
          countries={countries}
          searchCountry={searchCountry ?? ""}
          onSelectCountry={handleCountrySelect}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
          fileName={fileName}
          setFileName={setFileName}
          handleFileChange={handleFileChange}
          accountant={accountant}
          onRemoveAccountant={handleRemove}
          inviteOpen={showPopupAccount}
          setInviteOpen={setShowPopupAccount}
          formValuesInvite={formValuesInvite}
          handleInviteChange={handleInviteChange}
          errorsAccountant={errorsAccountant}
          setErrorsAccountant={setErrorsAccountant}
          onSendInvite={handleSendInvite}
          cancelSubscriptionOpen={showPopupBilling}
          setCancelSubscriptionOpen={setShowPopupBilling}
          listUser={listUser}
          listLocation={listLocation}
          filterUsers={filterUsers}
          filterLocations={filterLocations}
          onPageUsers={handleReceivePageNumberUsers}
          onPageLocations={handleReceivePageNumberLocations}
          onDeleteItem={handleDeleteItem}
          onSaveInvoiceConfig={() => handleSaveInvoiceConfig({ preventDefault() {} } as any)}
          listBankDetails={listBankDetails}
          bankModalOpen={showBankModal}
          openBankModal={openBankModal}
          closeBankModal={closeBankModal}
          editingBankId={editingBankId}
          bankFormValues={bankFormValues}
          handleBankFormChange={handleBankFormChange}
          bankFormErrors={bankFormErrors}
          onSaveBankDetail={handleSaveBankDetail}
          onDeleteBankDetail={handleDeleteBankDetail}
          listServiceCharge={listServiceCharge}
          serviceChargeTotal={serviceChargeTotal}
          serviceChargeFilter={serviceChargeFilter}
          serviceChargeLoading={serviceChargeLoading}
          showServiceChargeForm={showServiceChargeForm}
          editingServiceChargeId={editingServiceChargeId}
          serviceChargeForm={serviceChargeForm}
          serviceChargeErrors={serviceChargeErrors}
          setServiceChargeForm={setServiceChargeForm}
          setServiceChargeValue={setServiceChargeValue}
          onAddServiceCharge={handleAddServiceCharge}
          onBackServiceCharge={handleBackServiceCharge}
          onEditServiceCharge={handleEditServiceCharge}
          onSaveServiceCharge={() => handleSaveServiceCharge({ preventDefault() {} } as any)}
          onServiceChargePage={handleServiceChargePageClick}
          deleteServiceChargeOpen={showDeleteServiceCharge}
          onAskDeleteServiceCharge={handleShowDeleteServiceCharge}
          onCancelDeleteServiceCharge={() => {
            setShowDeleteServiceCharge(false);
            setIdDeleteServiceCharge("");
          }}
          onConfirmDeleteServiceCharge={handleDeleteServiceCharge}
          listGratuity={listGratuity}
          gratuityTotal={gratuityTotal}
          gratuityFilter={gratuityFilter}
          gratuityLoading={gratuityLoading}
          showGratuityForm={showGratuityForm}
          editingGratuityId={editingGratuityId}
          gratuityForm={gratuityForm}
          gratuityErrors={gratuityErrors}
          setGratuityForm={setGratuityForm}
          gratuityLocations={gratuityLocations}
          gratuityTaxGroups={gratuityTaxGroups}
          gratuityScopeName={gratuityScopeName}
          onAddGratuity={handleAddGratuity}
          onBackGratuity={handleBackGratuity}
          onEditGratuity={handleEditGratuity}
          onSaveGratuity={() => handleSaveGratuity({ preventDefault() {} } as any)}
          onGratuityPage={handleGratuityPageClick}
          deleteGratuityOpen={showDeleteGratuity}
          onAskDeleteGratuity={handleShowDeleteGratuity}
          onCancelDeleteGratuity={() => {
            setShowDeleteGratuity(false);
            setIdDeleteGratuity("");
          }}
          onConfirmDeleteGratuity={handleDeleteGratuity}
          noticeOpen={showPopup}
          noticeMessage={messageErr}
          onCloseNotice={handleClosePopup}
        />
      </>
    );
  }

  return (
    <div {...kb.scopeProps}>
      <div style={{ height: "100%" }}>
        <div
          className="flex items-start scroll-container"
          style={{
            gap: "24px",
            height: "calc(100% - 66px)",
            flexWrap: "wrap",
            overflowY: "scroll",
          }}
        >
          <div
            role="tablist"
            aria-orientation="vertical"
            className="space-y-2"
            style={{
              padding: "16px",
              border: "1px solid #EBF0F0",
              borderRadius: "16px",
              width: isMobile ? "100%" : "calc(25% - 12px)",
            }}
          >
            <p
              className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
              {...sideTabProps("company")}
              onClick={() => {
                handleChangeTab("company");
              }}
              style={
                tab === "company"
                  ? {
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "ceter",
                    height: "100%",
                    color: "#05292A",
                    backgroundColor: "#EBF0F0",
                    fontWeight: "500",
                    borderRadius: "8px",
                  }
                  : {
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "ceter",
                    height: "100%",
                    color: "#05292A",
                    backgroundColor: "transparent",
                  }
              }
            >
              {language && language?.["Company Details"]
                ? language?.["Company Details"]
                : "Company Details"}
            </p>
            {
              listPermission?.find((v: any) => v.name === "Billing" && v.value) &&
              <p
                className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
                {...sideTabProps("billing")}
                onClick={() => {
                  handleChangeTab("billing");
                }}
                style={
                  tab === "billing"
                    ? {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "#EBF0F0",
                      fontWeight: "500",
                      borderRadius: "8px",
                    }
                    : {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "transparent",
                    }
                }
              >
                {language && language?.["Billing"]
                  ? language?.["Billing"]
                  : "Billing"}
              </p>
            }
            {
              listPermission?.find((v: any) => v.name === "Users" && v.value) &&
              <p
                className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
                {...sideTabProps("user")}
                onClick={() => {
                  handleChangeTab("user");
                }}
                style={
                  tab === "user"
                    ? {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "#EBF0F0",
                      fontWeight: "500",
                      borderRadius: "8px",
                    }
                    : {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "transparent",
                    }
                }
              >
                {language && language?.["Users"] ? language?.["Users"] : "Users"}
              </p>
            }
            <p
              className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
              {...sideTabProps("location")}
              onClick={() => {
                handleChangeTab("location");
              }}
              style={
                tab === "location"
                  ? {
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "ceter",
                    height: "100%",
                    color: "#05292A",
                    backgroundColor: "#EBF0F0",
                    fontWeight: "500",
                    borderRadius: "8px",
                  }
                  : {
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "ceter",
                    height: "100%",
                    color: "#05292A",
                    backgroundColor: "transparent",
                  }
              }
            >
              {language && language?.["Locations"]
                ? language?.["Locations"]
                : "Locations"}
            </p>
            {
              listPermission?.find((v: any) => v.name === "Invoice configurations" && v.value) &&
              <p
                className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
                {...sideTabProps("invoice")}
                onClick={() => {
                  handleChangeTab("invoice");
                }}
                style={
                  tab === "invoice"
                    ? {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "#EBF0F0",
                      fontWeight: "500",
                      borderRadius: "8px",
                    }
                    : {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "transparent",
                    }
                }
              >
                {language && language?.["Invoice configurations"]
                  ? language?.["Invoice configurations"]
                  : "Invoice configurations"}
              </p>
            }
            {listPermission?.find((v: any) => v.name === "Invoice configurations" && v.value) && (
           <p
                className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
                {...sideTabProps("serviceCharge")}
                onClick={() => {
                  handleChangeTab("serviceCharge");
                }}
                style={
                  tab === "serviceCharge"
                    ? {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "#EBF0F0",
                      fontWeight: "500",
                      borderRadius: "8px",
                    }
                    : {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "transparent",
                    }
                }
              >
                {language && language?.["Service charge"]
                  ? language?.["Service charge"]
                  : "Service charge"}
              </p>
            )}
            {listPermission?.find((v: any) => v.name === "Invoice configurations" && v.value) && (
           <p
                className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer"
                {...sideTabProps("gratuity")}
                onClick={() => {
                  handleChangeTab("gratuity");
                }}
                style={
                  tab === "gratuity"
                    ? {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "#EBF0F0",
                      fontWeight: "500",
                      borderRadius: "8px",
                    }
                    : {
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "ceter",
                      height: "100%",
                      color: "#05292A",
                      backgroundColor: "transparent",
                    }
                }
              >
                {language && language?.["Gratuity"]
                  ? language?.["Gratuity"]
                  : "Gratuity"}
              </p>
            )}
          </div>
          <div
            style={{
              height: isMobile ? `calc(100% - 275px)` : `100%`,
              width: isMobile ? "100%" : "calc(75% - 12px)",
              overflowY: "scroll",
            }}
            className="scroll-container"
          >
            {tab === "company" && (
              <>
                <form>
                  <div className="" style={{}}>
                    <div className="" style={{ width: "100%" }}>
                      <div>
                        <p
                          className="font-inter"
                          style={{
                            marginBottom: "28px",
                            fontSize: "20px",
                            fontWeight: "500",
                            color: "#222525",
                            lineHeight: "21px",
                          }}
                        >
                          {language && language?.["General details"]
                            ? language?.["General details"]
                            : "General details"}
                        </p>
                        <div style={{ marginTop: "16px" }}>
                          <div
                            className="flex items-center"
                            style={{ gap: "24px", flexWrap: "wrap" }}
                          >
                            <div
                              className="space-y-2"
                              style={{ width: "100%" }}
                            >
                              <div className="flex items-center">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Company Name"]
                                    ? language?.["Company Name"]
                                    : "Company Name"}
                                </p>
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{ color: "#BA0E13" }}
                                >
                                  {language && language?.["*"]
                                    ? language?.["*"]
                                    : "*"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.companyName}
                                  name="companyName"
                                  {...limitProps(companyLimits, "companyName")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.companyName} max={companyLimits.companyName?.maxLength} />
                              </div>
                              {errors.companyName && (
                                <p className="error">{errors.companyName}</p>
                              )}
                            </div>
                            <div
                              className="space-y-2"
                              style={{
                                width: isMobile
                                  ? "calc(50% - 12px)"
                                  : "calc(33% - 12px)",
                              }}
                            >
                              <div className="flex items-center">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Company Number"]
                                    ? language?.["Company Number"]
                                    : "Company Number"}
                                </p>
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{ color: "#BA0E13" }}
                                >
                                  {language && language?.["*"]
                                    ? language?.["*"]
                                    : "*"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  type="text"
                                  name="companyNumber"
                                  {...limitProps(companyLimits, "companyNumber")}
                                  // onKeyDown={validateEmail}
                                  value={formValues?.companyNumber}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.companyNumber} max={companyLimits.companyNumber?.maxLength} />
                              </div>
                              {errors.companyNumber && (
                                <p className="error">{errors.companyNumber}</p>
                              )}
                            </div>
                            <div
                              className="space-y-2"
                              style={{
                                width: isMobile
                                  ? "calc(50% - 12px)"
                                  : "calc(33% - 12px)",
                              }}
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Fiscal Number"]
                                    ? language?.["Fiscal Number"]
                                    : "Fiscal Number"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  type="text"
                                  name="fiscalNumber"
                                  {...limitProps(companyLimits, "fiscalNumber")}
                                  // onKeyDown={validateEmail}
                                  value={formValues?.fiscalNumber}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.fiscalNumber} max={companyLimits.fiscalNumber?.maxLength} />
                              </div>
                              {errors.fiscalNumber && (
                                <p className="error">{errors.fiscalNumber}</p>
                              )}
                            </div>
                            <div
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(33% - 12px)",
                              }}
                              className="space-y-2"
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["TAX Code"]
                                    ? language?.["TAX Code"]
                                    : "TAX Code"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  type="text"
                                  name="taxCode"
                                  {...limitProps(companyLimits, "taxCode")}
                                  value={formValues?.taxCode}
                                  onKeyDown={validateOnlyNumbersNotThree}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.taxCode} max={companyLimits.taxCode?.maxLength} />
                              </div>
                              {errors.taxCode && (
                                <p className="error">{errors.taxCode}</p>
                              )}
                            </div>
                            <div
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(33% - 12px)",
                              }}
                              className="space-y-2"
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Address line 1"]
                                    ? language?.["Address line 1"]
                                    : "Address line 1"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.addressLine1}
                                  name="addressLine1"
                                  {...limitProps(companyLimits, "addressLine1")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.addressLine1} max={companyLimits.addressLine1?.maxLength} />
                              </div>
                              {errors.addressLine1 && (
                                <p className="error">{errors.addressLine1}</p>
                              )}
                            </div>
                            <div
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(33% - 12px)",
                              }}
                              className="space-y-2"
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Address line 2"]
                                    ? language?.["Address line 2"]
                                    : "Address line 2"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.addressLine2}
                                  name="addressLine2"
                                  {...limitProps(companyLimits, "addressLine2")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.addressLine2} max={companyLimits.addressLine2?.maxLength} />
                              </div>
                              {errors.addressLine2 && (
                                <p className="error">{errors.addressLine2}</p>
                              )}
                            </div>
                            <div
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(33% - 12px)",
                              }}
                              className="space-y-2"
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Postal Code"]
                                    ? language?.["Postal Code"]
                                    : "Postal Code"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.postalCode}
                                  onKeyDown={validateNoSpecialChars}
                                  name="postalCode"
                                  {...limitProps(companyLimits, "postalCode")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.postalCode} max={companyLimits.postalCode?.maxLength} />
                              </div>
                              {errors.postalCode && (
                                <p className="error">{errors.postalCode}</p>
                              )}
                            </div>
                            <div
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(50% - 12px)",
                              }}
                              className="space-y-2"
                            >
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["City"]
                                    ? language?.["City"]
                                    : "City"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.city}
                                  onKeyDown={validateNoSpecialChars}
                                  name="city"
                                  {...limitProps(companyLimits, "city")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.city} max={companyLimits.city?.maxLength} />
                              </div>
                              {errors.city && (
                                <p className="error">{errors.city}</p>
                              )}
                            </div>
                            <div
                              className="w-full space-y-2"
                              style={{
                                width: isMobile
                                  ? "calc(100%)"
                                  : "calc(50% - 12px)",
                              }}
                            >
                              <p className="text-[14px] font-inter leading-[20px]">
                                {language && language?.["Country"]
                                  ? language?.["Country"]
                                  : "Country"}
                              </p>
                              <div
                                className="relative"
                                ref={dropdownCountryRef}
                              >
                                <input
                                  type="text"
                                  role="combobox"
                                  aria-expanded={isCountryDropdownOpen}
                                  aria-autocomplete="list"
                                  value={searchCountry}
                                  onChange={(e) => {
                                    setSearchCountry(e.target.value);
                                    setCountryHighlight(-1);
                                    setIsCountryDropdownOpen(true);
                                  }}
                                  onClick={() => {
                                    setCountryHighlight(-1);
                                    setIsCountryDropdownOpen(true);
                                  }}
                                  onKeyDown={handleCountryKeyDown}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                {errors.countryId && (
                                  <p className="error">{errors.countryId}</p>
                                )}
                                {isCountryDropdownOpen && (
                                  <div ref={countryListRef} role="listbox" className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                    {visibleCountries
                                      .map((country, index) => (
                                        <div
                                          key={country.id}
                                          role="option"
                                          aria-selected={index === countryHighlight}
                                          className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                          style={index === countryHighlight ? { backgroundColor: "#E7F1F1" } : undefined}
                                          onMouseDown={(e) => e.preventDefault()}
                                          onClick={() =>
                                            handleCountrySelect(
                                              country.id,
                                              country.name,
                                            )
                                          }
                                        >
                                          {country.name}
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="w-full"
                        style={{
                          height: "1px",
                          borderRadius: "2px",
                          backgroundColor: "#EBF0F0",
                          margin: "32px 0px",
                        }}
                      ></div>
                      <div>
                        <p
                          className="font-inter"
                          style={{
                            marginBottom: "28px",
                            fontSize: "20px",
                            fontWeight: "500",
                            color: "#222525",
                            lineHeight: "21px",
                          }}
                        >
                          {language && language?.["Contact details"]
                            ? language?.["Contact details"]
                            : "Contact details"}
                        </p>
                        <div style={{ marginTop: "28px" }}>
                          <div className="space-y-2">
                            <div className="flex items-center justify-between">
                              <p
                                className="text-[14px] font-inter leading-[20px]"
                                style={{ color: "#4A5353" }}
                              >
                                {language && language?.["Email address"]
                                  ? language?.["Email address"]
                                  : "Email address"}
                              </p>
                            </div>
                            <div className="w-full">
                              <input
                                value={formValues?.emailAddress}
                                onKeyDown={validateNoSpecialChars}
                                name="emailAddress"
                                onChange={(e: any) => {
                                  handleChange(e);
                                }}
                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                              />
                            </div>
                            {errors.emailAddress && (
                              <p className="error">{errors.emailAddress}</p>
                            )}
                          </div>
                          <div
                            className="flex items-center"
                            style={{ gap: "24px", marginTop: "24px" }}
                          >
                            <div style={{ width: "50%" }} className="space-y-2">
                              <div className="flex items-center justify-between">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{ color: "#4A5353" }}
                                >
                                  {language && language?.["Phone Number"]
                                    ? language?.["Phone Number"]
                                    : "Phone Number"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.phoneNumber}
                                  onKeyDown={validatePhoneNumber}
                                  name="phoneNumber"
                                  {...limitProps(companyLimits, "phoneNumber")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.phoneNumber} max={companyLimits.phoneNumber?.maxLength} />
                              </div>
                              {errors.phoneNumber && (
                                <p className="error">{errors.phoneNumber}</p>
                              )}
                            </div>
                            <div style={{ width: "50%" }} className="space-y-2">
                              <div className="flex items-center">
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{
                                    color: "#4A5353",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Invoice Prefix"]
                                    ? language?.["Invoice Prefix"]
                                    : "Invoice Prefix"}
                                </p>
                                <p
                                  className="text-[14px] font-inter leading-[20px]"
                                  style={{ color: "#BA0E13" }}
                                >
                                  {language && language?.["*"]
                                    ? language?.["*"]
                                    : "*"}
                                </p>
                              </div>
                              <div className="w-full">
                                <input
                                  value={formValues?.invoicePrefix}
                                  name="invoicePrefix"
                                  {...limitProps(companyLimits, "invoicePrefix")}
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.invoicePrefix} max={companyLimits.invoicePrefix?.maxLength} />
                              </div>
                              {errors.invoicePrefix && (
                                <p className="error">{errors.invoicePrefix}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="w-full"
                        style={{
                          height: "1px",
                          borderRadius: "2px",
                          backgroundColor: "#EBF0F0",
                          margin: "32px 0px",
                        }}
                      ></div>
                      <div style={{}}>
                        <p
                          className="font-inter"
                          style={{
                            marginBottom: "28px",
                            fontSize: "20px",
                            fontWeight: "500",
                            color: "#222525",
                            lineHeight: "21px",
                          }}
                        >
                          {language && language?.["Branding"]
                            ? language?.["Branding"]
                            : "Branding"}
                        </p>
                        <div>
                          <div
                            className="flex items-center justify-between"
                            style={{ marginTop: "28px" }}
                          >
                            <p
                              className="text-[14px] font-inter leading-[20px]"
                              style={{ color: "#4A5353", fontWeight: "500" }}
                            >
                              {language && language?.["Company logo"]
                                ? language?.["Company logo"]
                                : "Company logo"}
                            </p>
                          </div>
                          <div
                            className="lg:flex items-center"
                            style={{ gap: "16px", marginTop: "12px" }}
                          >
                            <div
                              className="flex items-center justify-center"
                              style={{
                                width: "84px",
                                height: "84px",
                                borderRadius: "72px",
                                backgroundColor: "#EBF0F0",
                              }}
                            >
                              <div className="w-6 h-6 flex items-center justify-center">
                                {formValues?.companyLogo ? (
                                  <img
                                    src={formValues?.companyLogo}
                                    alt="Uploaded Preview"
                                    style={{
                                      height: "24px",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <PhotoIcon />
                                )}
                              </div>
                            </div>
                            <div
                              className="flex items-center justify-center"
                              style={{
                                padding: "20px",
                                border: `1px dashed ${isDragging ? "#3AC0C4" : "#DBE4E4"}`,
                                borderRadius: "16px",
                                width: isMobile ? "100%" : "calc(100% - 100px)",
                                marginTop: isMobile ? "16px" : "0px",
                              }}
                              onDrop={handleDrop}
                              onDragOver={handleDragOver}
                              onDragLeave={handleDragLeave}
                            >
                              <div className="space-y-2 text-center">
                                <div className="flex items-center justify-center">
                                  <UploadIcon />
                                </div>
                                <p className="text-[14px] text-main leading-[20px] font-inter font-medium">
                                  {fileName
                                    ? `File: ${fileName}`
                                    : language &&
                                      language?.[
                                      "Drag and drop your logo here"
                                      ]
                                      ? language?.[
                                      "Drag and drop your logo here"
                                      ]
                                      : "Drag and drop your logo here"}
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    color: "#819596",
                                    marginBottom: "8px",
                                  }}
                                  className=" text-main leading-[20px] font-inter"
                                >
                                  {language && language?.["OR"]
                                    ? language?.["OR"]
                                    : "OR"}
                                </p>
                                <label
                                  htmlFor="fileInput"
                                  className="text-[14px] font-inter font-semibold leading-[18px] cursor-pointer"
                                  style={{
                                    color: "#0F7679",
                                    padding: "8px 16px",
                                    border: "1px solid #C9D7D8",
                                    borderRadius: "30px",
                                  }}
                                >
                                  {language && language?.["Browse file"]
                                    ? language?.["Browse file"]
                                    : "Browse file"}
                                </label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  style={{ display: "none" }}
                                  id="fileInput"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ marginTop: "24px" }}>
                          <div className="space-y-2">
                            <div className="flex items-center">
                              <p
                                className="text-[14px] font-inter leading-[20px]"
                                style={{ color: "#4A5353", fontWeight: "500" }}
                              >
                                {language && language?.["Web URL"]
                                  ? language?.["Web URL"]
                                  : "Web URL"}
                              </p>
                              <p
                                className="text-[14px] font-inter leading-[20px]"
                                style={{ color: "#BA0E13" }}
                              >
                                {language && language?.["*"]
                                  ? language?.["*"]
                                  : "*"}
                              </p>
                            </div>
                            <div className="w-full">
                              <input
                                value={formValues?.webUrl}
                                name="webUrl"
                                {...limitProps(companyLimits, "webUrl")}
                                onChange={(e: any) => {
                                  handleChange(e);
                                }}
                                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                              />
                              <FieldCounter value={formValues?.webUrl} max={companyLimits.webUrl?.maxLength} />
                            </div>
                            {errors.webUrl && (
                              <p className="error">{errors.webUrl}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        padding: "24px",
                        marginTop: "32px",
                        backgroundColor: "#EBF0F0",
                        borderRadius: "16px",
                      }}
                    >
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "20px",
                          fontWeight: "500",
                          color: "#222525",
                          lineHeight: "22px",
                        }}
                      >
                        {language && language?.["Invite your accountant"]
                          ? language?.["Invite your accountant"]
                          : "Invite your accountant"}
                      </p>
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#4A5353",
                          lineHeight: "22px",
                          marginTop: "8px",
                        }}
                      >
                        {language &&
                          language?.[
                          "Easily share access with your accountant so they can review reports and manage finances"
                          ]
                          ? language?.[
                          "Easily share access with your accountant so they can review reports and manage finances"
                          ]
                          : "Easily share access with your accountant so they can review reports and manage finances"}
                      </p>
                      <div style={{ marginTop: "24px" }}>
                        {accountant?.map((v: any) => {
                          return (
                            <div
                              className="flex items-center justify-between"
                              style={{ marginTop: "12px" }}
                            >
                              <div>
                                <p
                                  className="font-inter"
                                  style={{
                                    color: "#222525",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                  }}
                                >
                                  {v?.user?.firstName} {v?.user?.lastName}
                                </p>
                                <p
                                  className="font-inter"
                                  style={{ fontSize: "12px", color: "#595959" }}
                                >
                                  {v?.user?.emailAddress}
                                </p>
                              </div>
                              <button
                                type="button"
                                className="flex items-center justify-center cursor-pointer"
                                style={{
                                  borderRadius: "6px",
                                  height: "40px",
                                  backgroundColor: "#E40F03",
                                  padding: "0px 12px",
                                }}
                                onClick={() => [handleRemove(v)]}
                              >
                                <p
                                  className="font-inter"
                                  style={{
                                    fontSize: "14px",
                                    color: "white",
                                    lineHeight: "22px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {language && language?.["Remove"]
                                    ? language?.["Remove"]
                                    : "Remove"}
                                </p>
                              </button>
                            </div>
                          );
                        })}
                        <button
                          type="button"
                          className="cursor-pointer flex items-center justify-center"
                          style={{
                            gap: "8px",
                            borderRadius: "30px",
                            backgroundColor: "#0F7679",
                            marginTop: "16px",
                            width: "fit-content",
                            padding: "8px 24px 8px 16px",
                          }}
                          onClick={() => {
                            setShowPopupAccount(true);
                          }}
                        >
                          <div className="w-6 h-6 flex items-center justify-center">
                            <PlusIcon />
                          </div>
                          <p
                            className="font-inter"
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#FFFFFF",
                              lineHeight: "22px",
                            }}
                          >
                            {language && language?.["Invite accountant"]
                              ? language?.["Invite accountant"]
                              : "Invite accountant"}
                          </p>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div
                  ref={inviteDialogRef}
                  role="dialog"
                  aria-modal="true"
                  className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showPopupAccount ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                  style={{
                    backgroundColor: "#22252552",
                    zIndex: "20",
                    transition: "opacity 0.3s ease, visibility 0.3s ease",
                    visibility: showPopupAccount ? "visible" : "hidden",
                    width: "100%",
                  }}
                >
                  {/* The scope sits inside role="dialog": the hook skips a dialog nested in its own scope. */}
                  <div {...inviteKb.scopeProps}>
                  <div
                    className={`transform transition-transform duration-300 ease-in-out ${showPopupAccount ? "translate-y-0" : "translate-y-4 opacity-0"}`}
                    style={{
                      padding: "24px",
                      borderRadius: "24px",
                      backgroundColor: "white",
                      width: "520px",
                      transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <p
                        style={{ fontSize: "20px", color: "#222525" }}
                        className="font-semibold font-inter leading-[24px]"
                      >
                        {language && language?.["Invite accountant"]
                          ? language?.["Invite accountant"]
                          : "Invite accountant"}
                      </p>
                      <button
                        type="button"
                        aria-label={language?.["Close"] ?? "Close"}
                        onClick={() => {
                          (setShowPopupAccount(false), setErrorsAccountant({}));
                        }}
                        className="flex items-center justify-center cursor-pointer"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      >
                        <CloseIcon />
                      </button>
                    </div>
                    <div className="" style={{ marginTop: "24px" }}>
                      <div
                        className="flex items-center"
                        style={{ gap: "24px" }}
                      >
                        <div className="space-y-2" style={{ width: "50%" }}>
                          <div className="flex items-center justify-between">
                            <p
                              className="text-[14px] font-inter leading-[20px]"
                              style={{ color: "#4A5353", fontWeight: "500" }}
                            >
                              {language && language?.["First Name"]
                                ? language?.["First Name"]
                                : "First Name"}
                            </p>
                          </div>
                          <div className="w-full">
                            <input
                              value={formValuesInvite?.firstName}
                              onKeyDown={validateNoSpecialChars}
                              name="firstName"
                              onChange={(e: any) => {
                                handleInviteChange(e);
                              }}
                              className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                            />
                          </div>
                          {errorsAccountant.firstName && (
                            <p className="error">
                              {errorsAccountant.firstName}
                            </p>
                          )}
                        </div>
                        <div className="space-y-2" style={{ width: "50%" }}>
                          <div className="flex items-center justify-between">
                            <p
                              className="text-[14px] font-inter leading-[20px]"
                              style={{ color: "#4A5353", fontWeight: "500" }}
                            >
                              {language && language?.["Last Name"]
                                ? language?.["Last Name"]
                                : "Last Name"}
                            </p>
                          </div>
                          <div className="w-full">
                            <input
                              value={formValuesInvite?.lastName}
                              onKeyDown={validateNoSpecialChars}
                              name="lastName"
                              onChange={(e: any) => {
                                handleInviteChange(e);
                              }}
                              className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                            />
                          </div>
                          {errorsAccountant.lastName && (
                            <p className="error">{errorsAccountant.lastName}</p>
                          )}
                        </div>
                      </div>
                      <div style={{ marginTop: "24px" }} className="space-y-2">
                        <div className="flex items-center justify-between">
                          <p
                            className="text-[14px] font-inter leading-[20px]"
                            style={{ color: "#4A5353", fontWeight: "500" }}
                          >
                            {language && language?.["Email Address"]
                              ? language?.["Email Address"]
                              : "Email Address"}
                          </p>
                        </div>
                        <div className="w-full">
                          <input
                            value={formValuesInvite?.emailAddress}
                            // onKeyDown={validateNoSpecialChars}
                            name="emailAddress"
                            onChange={(e: any) => {
                              handleInviteChange(e);
                            }}
                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                          />
                        </div>
                        {errorsAccountant.emailAddress && (
                          <p className="error">
                            {errorsAccountant.emailAddress}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      className="w-full flex items-center justify-end"
                      style={{ marginTop: "24px", gap: "12px" }}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          (setShowPopupAccount(false), setErrorsAccountant({}));
                        }}
                        style={{
                          padding: "10px 24px",
                          borderRadius: "30px",
                          color: "#222525",
                          fontSize: "14px",
                          fontWeight: "500",
                          border: "1px solid #C9D7D8",
                        }}
                        className="font-inter cursor-pointer"
                      >
                        {language && language?.["Cancel"]
                          ? language?.["Cancel"]
                          : "Cancel"}
                      </button>
                      <button
                        type="button"
                        {...inviteKb.primaryProps(handleSendInvite)}
                        style={{
                          padding: "10px 24px",
                          borderRadius: "30px",
                          color: "#FFFFFF",
                          fontSize: "14px",
                          fontWeight: "500",
                          backgroundColor: "#0F7679",
                        }}
                        className="font-inter cursor-pointer"
                      >
                        <p className="text-[14px] leading-[22px] font-inter">
                          {language && language?.["Send invite"]
                            ? language?.["Send invite"]
                            : "Send invite"}
                        </p>
                      </button>
                    </div>
                  </div>
                  </div>
                </div>
              </>
            )}
            {tab === "billing" && (
              <>
                <div style={{ height: `100%` }}>
                  <p
                    className="font-inter"
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "20.8px",
                      color: "#222525",
                      marginBottom: "20px",
                    }}
                  >
                    {language?.["Billing history"] ?? "Billing history"}
                  </p>
                  <div
                    style={
                      isMobile
                        ? { height: "" }
                        : { height: "calc(100% - 80px)" }
                    }
                  >
                    {isMobile ? (
                      <TableCompanyReportMobile
                        PER_PAGE={filterBilling.limit}
                        pageClick={filterBilling.page}
                        languages={language}
                        loading={loading}
                        path="/companies/billing/"
                        data_table={[
                          {
                            id: "",
                            "Invoice No": "#123123",
                            Title: "Service for air conditioning",
                            Category: "Category",
                            Date: "01/01/2025",
                            Status: "Unpaid",
                          },
                        ]}
                        count={1}
                        handleSendPageNumber={handleReceivePageNumberBilling}
                        handleDelete={handleShowDelete}
                      />
                    ) : (
                      <TableCompanyReport
                        PER_PAGE={filterBilling.limit}
                        pageClick={filterBilling.page}
                        languages={language}
                        loading={loading}
                        path="/companies/billing/"
                        data_table={[
                          {
                            id: "",
                            "Invoice No": "#123123",
                            Title: "Service for air conditioning",
                            Category: "Category",
                            Date: "01/01/2025",
                            Status: "Unpaid",
                          },
                        ]}
                        count={1}
                        handleSendPageNumber={handleReceivePageNumberBilling}
                        handleDelete={handleShowDelete}
                      />
                    )}
                  </div>
                  <div
                    className="lg:flex items-center justify-between"
                    style={{
                      padding: "20px",
                      gap: "20px",
                      backgroundColor: "#F8F8F8",
                      border: "1px solid #EBF0F0",
                      borderRadius: "12px",
                    }}
                  >
                    <div className="">
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          lineHeight: "20.8px",
                          color: "#222525",
                        }}
                      >
                        {language?.["Cancel Your Subscription"] ??
                          "Cancel Your Subscription"}
                      </p>
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "16.8px ",
                          color: "#4A5353",
                          marginTop: "4px",
                        }}
                      >
                        {" "}
                        {language?.[
                          "Stop your premium account billing anytime. You can resume your subscription whenever you want."
                        ] ??
                          "Stop your premium account billing anytime. You can resume your subscription whenever you want."}
                      </p>
                    </div>
                    <button
                      type="button"
                      className="font-inter font-medium cursor-pointer"
                      style={{
                        marginTop: isMobile ? "20px" : "0px",
                        padding: "10px 24px",
                        borderRadius: "30px",
                        backgroundColor: "white",
                        color: "#BA0E13",
                        border: "1px solid #BA0E13",
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      onClick={() => {
                        setShowPopupBilling(true);
                      }}
                    >
                      {language?.["Cancel Subscription"] ??
                        "Cancel Subscription"}
                    </button>
                  </div>
                </div>
              </>
            )}
            {tab === "user" && (
              <>
                <div style={{ height: `100%` }}>
                  <div
                    style={
                      isMobile
                        ? { height: "" }
                        : { height: "calc(100% - 80px)" }
                    }
                  >
                    {isMobile ? (
                      <TableCompanyReportMobile
                        PER_PAGE={filterUsers.limit}
                        pageClick={filterUsers.page}
                        languages={language}
                        loading={loading}
                        path="/companies/user/"
                        data_table={listUser?.data}
                        count={listUser?.count}
                        handleSendPageNumber={handleReceivePageNumberUsers}
                        handleDelete={handleShowDelete}
                      />
                    ) : (
                      <TableCompanyReport
                        PER_PAGE={filterUsers.limit}
                        pageClick={filterUsers.page}
                        languages={language}
                        loading={loading}
                        path="/companies/user/"
                        data_table={listUser?.data}
                        count={listUser?.count}
                        handleSendPageNumber={handleReceivePageNumberUsers}
                        handleDelete={handleShowDelete}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
            {tab === "location" && (
              <>
                <div style={{ height: `100%` }}>
                  <div
                    style={
                      isMobile
                        ? { height: "" }
                        : { height: "calc(100% - 80px)" }
                    }
                  >
                    {isMobile ? (
                      <TableCompanyReportMobile
                        PER_PAGE={filterLocations.limit}
                        pageClick={filterLocations.page}
                        languages={language}
                        loading={loading}
                        path="/companies/location/"
                        data_table={listLocation?.data}
                        count={listLocation?.count}
                        handleSendPageNumber={handleReceivePageNumberLocations}
                        handleDelete={handleShowDelete}
                      />
                    ) : (
                      <TableCompanyReport
                        PER_PAGE={filterLocations.limit}
                        pageClick={filterLocations.page}
                        languages={language}
                        loading={loading}
                        path="/companies/location/"
                        data_table={listLocation?.data}
                        count={listLocation?.count}
                        handleSendPageNumber={handleReceivePageNumberLocations}
                        handleDelete={handleShowDelete}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
            {tab === "invoice" && (
              <>
                <form>
                  <p
                    className="font-inter"
                    style={{
                      marginBottom: "28px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#222525",
                      lineHeight: "21px",
                    }}
                  >
                    {language && language?.["Invoice configurations"]
                      ? language?.["Invoice configurations"]
                      : "Invoice configurations"}
                  </p>
                  <p
                    className="font-inter"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#4A5353",
                      lineHeight: "22px",
                      marginBottom: "24px",
                    }}
                  >
                    {language && language?.["Manage how invoice numbers and prefixes are set for this company. These settings are used when creating invoices."]
                      ? language?.["Manage how invoice numbers and prefixes are set for this company. These settings are used when creating invoices."]
                      : "Manage how invoice numbers and prefixes are set for this company. These settings are used when creating invoices."}
                  </p>
                  <div
                    className="space-y-2"
                    style={{ maxWidth: "400px" }}
                  >
                    <div className="flex items-center">
                      <p
                        className="text-[14px] font-inter leading-[20px]"
                        style={{
                          color: "#4A5353",
                          fontWeight: "500",
                        }}
                      >
                        {language && language?.["Invoice Prefix"]
                          ? language?.["Invoice Prefix"]
                          : "Invoice Prefix"}
                      </p>
                      <p
                        className="text-[14px] font-inter leading-[20px]"
                        style={{ color: "#BA0E13" }}
                      >
                        {language && language?.["*"] ? language?.["*"] : "*"}
                      </p>
                    </div>
                    <div className="w-full">
                      <input
                        value={formValues?.invoicePrefix ?? ""}
                        name="invoicePrefix"
                        {...limitProps(companyLimits, "invoicePrefix")}
                        onChange={(e: any) => handleChange(e)}
                        placeholder={language?.["e.g. INV-"] ?? "e.g. INV-"}
                        className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                      />
                      <FieldCounter value={formValues?.invoicePrefix} max={companyLimits.invoicePrefix?.maxLength} />
                    </div>
                    {errors.invoicePrefix && (
                      <p className="error">{errors.invoicePrefix}</p>
                    )}
                  </div>
                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "#EBF0F0",
                      margin: "32px 0",
                    }}
                  />
                  <p
                    className="font-inter"
                    style={{
                      marginBottom: "16px",
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#222525",
                    }}
                  >
                    {language?.["Bank details"] ?? "Bank details"}
                  </p>
                  <p
                    className="font-inter"
                    style={{
                      fontSize: "14px",
                      color: "#4A5353",
                      lineHeight: "22px",
                      marginBottom: "16px",
                    }}
                  >
                    {language?.["Add bank accounts to show on invoices (e.g. for payment instructions)."] ?? "Add bank accounts to show on invoices (e.g. for payment instructions)."}
                  </p>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", marginBottom: "16px" }}>
                    <button
                      type="button"
                      onClick={() => openBankModal()}
                      className="font-inter cursor-pointer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 20px",
                        borderRadius: "30px",
                        backgroundColor: "#0F7679",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "500",
                        border: "none",
                      }}
                    >
                      <PlusIcon />
                      {language?.["Add bank detail"] ?? "Add bank detail"}
                    </button>
                  </div>
                  {listBankDetails.data?.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      {listBankDetails.data.map((bank: any) => (
                        <div
                          key={bank.id}
                          className="font-inter"
                          style={{
                            padding: "16px",
                            border: "1px solid #EBF0F0",
                            borderRadius: "12px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                            gap: "12px",
                          }}
                        >
                          <div style={{ flex: 1, minWidth: "200px" }}>
                            <p style={{ fontSize: "14px", fontWeight: "600", color: "#222525", marginBottom: "4px" }}>
                              {bank.bankName}
                            </p>
                            {(bank.IBAN || bank.accountNo) && (
                              <p style={{ fontSize: "13px", color: "#4A5353" }}>
                                {bank.IBAN || bank.accountNo}
                                {bank.SWIFT ? ` · ${bank.SWIFT}` : ""}
                              </p>
                            )}
                            {bank.bankLocation && (
                              <p style={{ fontSize: "13px", color: "#4A5353", marginTop: "2px" }}>{bank.bankLocation}</p>
                            )}
                          </div>
                          <div style={{ display: "flex", gap: "8px" }}>
                            <button
                              type="button"
                              onClick={() => openBankModal(bank)}
                              style={{
                                padding: "8px",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                borderRadius: "8px",
                              }}
                              aria-label="Edit"
                            >
                              <EditIconV2 />
                            </button>
                            <button
                              type="button"
                              onClick={() => handleDeleteBankDetail(bank.id)}
                              style={{
                                padding: "8px",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                borderRadius: "8px",
                              }}
                              aria-label="Delete"
                            >
                              <DeleteIconV2 />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="font-inter" style={{ fontSize: "14px", color: "#819596" }}>
                      {language?.["No bank details yet. Add one to display on invoices."] ?? "No bank details yet. Add one to display on invoices."}
                    </p>
                  )}
                </form>
              </>
            )}
            {tab === "serviceCharge" && (
              <>
                <form className="h-full">
                  <div className="w-full flex items-center justify-between" style={{ marginBottom: "20px", gap: "12px", flexWrap: "wrap" }}>
                    <div className="flex items-center" style={{ gap: "8px" }}>
                      {showServiceChargeForm && (
                        <button
                          type="button"
                          className="w-6 h-6 flex items-center justify-center cursor-pointer"
                          onClick={handleBackServiceCharge}
                          aria-label="Back service charge list"
                          style={{ background: "transparent", border: "none", padding: 0 }}
                        >
                          <BackIcon />
                        </button>
                      )}
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "20px",
                          fontWeight: "500",
                          color: "#222525",
                          lineHeight: "28px",
                        }}
                      >
                        {language?.["Service charge"] ?? "Service charge"}
                      </p>
                    </div>
                    {/* A company may hold at most one service charge: the Add
                        affordance exists only while there is none. */}
                    {!showServiceChargeForm && listServiceCharge.length === 0 && !serviceChargeLoading && (
                      <button
                        type="button"
                        onClick={handleAddServiceCharge}
                        className="font-inter cursor-pointer flex items-center"
                        style={{
                          borderRadius: "30px",
                          color: "#FFFFFF",
                          fontSize: "14px",
                          fontWeight: "500",
                          backgroundColor: "#0F7679",
                          padding: "10px 24px",
                          gap: "8px",
                          border: "none",
                        }}
                      >
                        <PlusIcon />
                        <span>{language?.["Add service charge"] ?? "Add service charge"}</span>
                      </button>
                    )}
                    {!showServiceChargeForm && listServiceCharge.length > 0 && (
                      <p
                        className="font-inter"
                        style={{ fontSize: "14px", lineHeight: "20px", color: "#819596" }}
                      >
                        {language?.["A company can have only one service charge."] ??
                          "A company can have only one service charge."}
                      </p>
                    )}
                  </div>
                  {serviceChargeLoading && (
                    <div style={{ position: "relative", minHeight: "240px" }}>
                      <LoadingV2 />
                    </div>
                  )}
                  {!showServiceChargeForm && listServiceCharge.length > 0 && (
                    <div style={{ position: "relative", height: "calc(100% - 61px)"}}>
                      {!serviceChargeLoading && (
                        <div className="w-full flex flex-col" style={{ height: "100%" }}>
                          <div
                            className="scroll-container"
                            style={{
                              height: serviceChargeTotal > serviceChargeFilter.limit ? "calc(100% - 92px)" : "100%",
                              overflowY: "auto",
                              paddingBottom: "12px",
                            }}
                          >
                            <div style={{ border: "1px solid #EBF0F0", borderRadius: "12px", overflow: "hidden" }}>
                              {listServiceCharge.map((item, index) => (
                                <div
                                  key={item.id}
                                  className="flex items-center justify-between"
                                  style={{
                                    padding: "12px 16px",
                                    borderBottom: index === listServiceCharge.length - 1 ? "none" : "1px solid #EBF0F0",
                                  }}
                                >
                                  <div className="flex items-center" style={{ width: "calc(100% - 152px)" }}>
                                    <p className="font-inter text-[14px]" style={{ width: "33.33%", color: "#222525", fontWeight: "500" }}>
                                      {item.chargeTypeText}
                                    </p>
                                    <p className="font-inter text-[14px]" style={{ width: "33.33%", color: "#222525" }}>
                                      {item.chargeType === 1 ? `${item.value}%` : item.value}
                                    </p>
                                    <p className="font-inter text-[14px]" style={{ width: "33.33%", color: "#4A5353" }}>
                                      {item.isEnabled ? (language?.["Enabled"] ?? "Enabled") : (language?.["Disabled"] ?? "Disabled")}
                                    </p>
                                  </div>
                                  <div className="flex items-center justify-end" style={{ width: "152px", gap: "8px" }}>
                                    {/* Editing the one charge is the action here, so it is labelled, not an icon. */}
                                    <button
                                      type="button"
                                      onClick={() => handleEditServiceCharge(item.id)}
                                      className="font-inter flex items-center"
                                      style={{
                                        padding: "8px 16px",
                                        gap: "8px",
                                        border: "1px solid #0F7679",
                                        borderRadius: "30px",
                                        background: "transparent",
                                        color: "#0F7679",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                      }}
                                      aria-label="Edit service charge"
                                    >
                                      <EditIconV2 />
                                      <span>{language?.["Edit"] ?? "Edit"}</span>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => handleShowDeleteServiceCharge(item.id)}
                                      style={{ padding: "8px", border: "none", background: "transparent", cursor: "pointer" }}
                                      aria-label="Delete service charge"
                                    >
                                      <DeleteIconV2 />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                          {/* One row at most, so the pager only appears if the API ever returns more. */}
                          {serviceChargeTotal > serviceChargeFilter.limit && (
                            <div className="w-full" style={{ marginTop: "24px" }}>
                              <div style={serviceChargePaginationContainerStyle}>
                                <p style={serviceChargePaginationTextStyle}>
                                  Showing {(serviceChargeFilter.page - 1) * serviceChargeFilter.limit + 1}-
                                  {Math.min(serviceChargeFilter.page * serviceChargeFilter.limit, serviceChargeTotal)} from {serviceChargeTotal}
                                </p>
                                <div style={serviceChargePaginationWrapperStyle}>
                                  <button
                                    type="button"
                                    onClick={() => handleServiceChargePageClick(serviceChargeFilter.page - 1)}
                                    style={serviceChargeArrowButtonStyle(serviceChargeFilter.page === 1)}
                                  >
                                    <ChevronLeftIcon />
                                  </button>
                                  {getServiceChargeVisiblePages().map((page, index) => (
                                    <button
                                      key={`${page}-${index}`}
                                      type="button"
                                      onClick={() => handleServiceChargePageClick(page)}
                                      disabled={page === "..."}
                                      style={getServiceChargeButtonStyle(page, page === serviceChargeFilter.page)}
                                    >
                                      {page}
                                    </button>
                                  ))}
                                  <button
                                    type="button"
                                    onClick={() => handleServiceChargePageClick(serviceChargeFilter.page + 1)}
                                    style={serviceChargeArrowButtonStyle(serviceChargeFilter.page === totalServiceChargePages)}
                                  >
                                    <ChevronRightIcon />
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {!showServiceChargeForm && !serviceChargeLoading && listServiceCharge.length === 0 && (
                    <div
                      className="flex flex-col items-center justify-center"
                      style={{ border: "1px solid #EBF0F0", borderRadius: "12px", padding: "40px 24px", gap: "6px" }}
                    >
                      <p className="font-inter" style={{ fontSize: "16px", fontWeight: "500", color: "#222525" }}>
                        {language?.["No service charge yet"] ?? "No service charge yet"}
                      </p>
                      <p className="font-inter" style={{ fontSize: "14px", color: "#819596", textAlign: "center" }}>
                        {language?.["Add one to apply a percentage or a fixed amount to sales."] ??
                          "Add one to apply a percentage or a fixed amount to sales."}
                      </p>
                    </div>
                  )}
                  {showServiceChargeForm && !serviceChargeLoading && (
                    <>
                      <div className="flex items-center" style={{ gap: "24px", flexWrap: "wrap", marginBottom: "24px" }}>
                        <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {language?.["Charge type"] ?? "Charge type"}
                          </p>
                          <div className="w-full" style={{ height: "48px" }}>
                            <DropdownSearch
                              refKey="serviceChargeType"
                              refs={{ serviceChargeType: dropdownServiceChargeTypeRef }}
                              openStates={{ serviceChargeType: isServiceChargeTypeOpen }}
                              open={(key) => key === "serviceChargeType" && setIsServiceChargeTypeOpen(true)}
                              close={(key) => key === "serviceChargeType" && setIsServiceChargeTypeOpen(false)}
                              data={chargeTypeOptions}
                              labelExtractor={(item) => item.name}
                              value={serviceChargeValue}
                              setValue={setServiceChargeValue}
                              onSelect={(item) => {
                                setServiceChargeValue(item.name);
                                setServiceChargeForm((prev) => ({ ...prev, chargeType: item.id }));
                              }}
                              placeholder={language?.["Select charge type"] ?? "Select charge type"}
                            />
                          </div>
                        </div>
                        <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {language?.["Value"] ?? "Value"}
                          </p>
                          <input
                            value={serviceChargeForm.value}
                            {...limitProps(serviceChargeLimits, serviceChargeValueField, "number")}
                            onChange={(e) => setServiceChargeForm((prev) => ({ ...prev, value: e.target.value }))}
                            className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                          />
                          {serviceChargeErrors.value && <p className="error">{serviceChargeErrors.value}</p>}
                        </div>
                      </div>
                      <div className="flex items-center" style={{ gap: "24px", flexWrap: "wrap" }}>
                        {[
                          { key: "enable", label: language?.["Enable"] ?? "Enable" },
                          { key: "optional", label: language?.["Make it optional"] ?? "Make it optional" },
                          { key: "taxable", label: language?.["Taxable"] ?? "Taxable" },
                        ].map((item) => (
                          <div key={item.key} style={{ minWidth: "160px" }}>
                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500", marginBottom: "8px" }}>
                              {item.label}
                            </p>
                            <div className="flex items-center" style={{ gap: "16px" }}>
                              <label className="flex items-center font-inter text-[14px]" style={{ gap: "8px", color: "#4A5353" }}>
                                <input
                                  type="radio"
                                  checked={serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "yes"}
                                  onChange={() => setServiceChargeForm((prev) => ({ ...prev, [item.key]: "yes" }))}
                                  style={{
                                    width: 20,
                                    height: 20,
                                    minWidth: 20,
                                    minHeight: 20,
                                    margin: 0,
                                    flexShrink: 0,
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    borderRadius: "50%",
                                    border:
                                      serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "yes"
                                        ? "1px solid #0F7679"
                                        : "1px solid #C9D7D8",
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                    backgroundImage:
                                      serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "yes"
                                        ? "radial-gradient(circle at center, #0F7679 0, #0F7679 5px, #ffffff 5.5px)"
                                        : "none",
                                  }}
                                />
                                {language?.["Yes"] ?? "Yes"}
                              </label>
                              <label className="flex items-center font-inter text-[14px]" style={{ gap: "8px", color: "#4A5353" }}>
                                <input
                                  type="radio"
                                  checked={serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "no"}
                                  onChange={() => setServiceChargeForm((prev) => ({ ...prev, [item.key]: "no" }))}
                                  style={{
                                    width: 20,
                                    height: 20,
                                    minWidth: 20,
                                    minHeight: 20,
                                    margin: 0,
                                    flexShrink: 0,
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    borderRadius: "50%",
                                    border:
                                      serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "no"
                                        ? "1px solid #0F7679"
                                        : "1px solid #C9D7D8",
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                    backgroundImage:
                                      serviceChargeForm[item.key as "enable" | "optional" | "taxable"] === "no"
                                        ? "radial-gradient(circle at center, #0F7679 0, #0F7679 5px, #ffffff 5.5px)"
                                        : "none",
                                  }}
                                />
                                {language?.["No"] ?? "No"}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </form>
              </>
            )}
            {tab === "gratuity" && (
              <>
                <form className="h-full">
                  <div className="w-full flex items-center justify-between" style={{ marginBottom: "20px", gap: "12px", flexWrap: "wrap" }}>
                    <div className="flex items-center" style={{ gap: "8px" }}>
                      {showGratuityForm && (
                        <button
                          type="button"
                          className="w-6 h-6 flex items-center justify-center cursor-pointer"
                          onClick={handleBackGratuity}
                          aria-label="Back to gratuity list"
                          style={{ background: "transparent", border: "none", padding: 0 }}
                        >
                          <BackIcon />
                        </button>
                      )}
                      <p
                        className="font-inter"
                        style={{
                          fontSize: "20px",
                          fontWeight: "500",
                          color: "#222525",
                          lineHeight: "28px",
                        }}
                      >
                        {showGratuityForm
                          ? editingGratuityId
                            ? tr("Edit gratuity settings")
                            : tr("Add gratuity settings")
                          : tr("Gratuity")}
                      </p>
                    </div>
                    {/* One company default plus one row per location, so Add stays available. */}
                    {!showGratuityForm && !gratuityLoading && (
                      <button
                        type="button"
                        onClick={handleAddGratuity}
                        className="font-inter cursor-pointer flex items-center"
                        style={{
                          borderRadius: "30px",
                          color: "#FFFFFF",
                          fontSize: "14px",
                          fontWeight: "500",
                          backgroundColor: "#0F7679",
                          padding: "10px 24px",
                          gap: "8px",
                          border: "none",
                        }}
                      >
                        <PlusIcon />
                        <span>{tr("Add gratuity settings")}</span>
                      </button>
                    )}
                  </div>
                  {gratuityLoading && (
                    <div style={{ position: "relative", minHeight: "240px" }}>
                      <LoadingV2 />
                    </div>
                  )}
                  {!showGratuityForm && !gratuityLoading && listGratuity.length > 0 && (
                    <div className="w-full flex flex-col" style={{ height: "calc(100% - 61px)" }}>
                      <div
                        className="scroll-container"
                        style={{
                          height: gratuityTotal > gratuityFilter.limit ? "calc(100% - 92px)" : "100%",
                          overflowY: "auto",
                          paddingBottom: "12px",
                        }}
                      >
                        <div style={{ border: "1px solid #EBF0F0", borderRadius: "12px", overflow: "hidden" }}>
                          {listGratuity.map((item, index) => (
                            <div
                              key={item.id}
                              className="flex items-center justify-between"
                              style={{
                                padding: "12px 16px",
                                borderBottom: index === listGratuity.length - 1 ? "none" : "1px solid #EBF0F0",
                              }}
                            >
                              <div className="flex items-center" style={{ width: "calc(100% - 152px)", gap: "12px" }}>
                                <p className="font-inter text-[14px]" style={{ width: "30%", color: "#222525", fontWeight: "500" }}>
                                  {gratuityScopeName(item)}
                                </p>
                                <p className="font-inter text-[14px]" style={{ width: "45%", color: "#222525" }}>
                                  {gratuityOptionSummary(item.options, tr)}
                                </p>
                                <p className="font-inter text-[14px]" style={{ width: "25%", color: "#4A5353" }}>
                                  {item.isEnabled ? tr("Enabled") : tr("Disabled")}
                                </p>
                              </div>
                              <div className="flex items-center justify-end" style={{ width: "152px", gap: "8px" }}>
                                <button
                                  type="button"
                                  onClick={() => handleEditGratuity(item.id)}
                                  className="font-inter flex items-center"
                                  style={{
                                    padding: "8px 16px",
                                    gap: "8px",
                                    border: "1px solid #0F7679",
                                    borderRadius: "30px",
                                    background: "transparent",
                                    color: "#0F7679",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                  }}
                                  aria-label="Edit gratuity settings"
                                >
                                  <EditIconV2 />
                                  <span>{tr("Edit")}</span>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleShowDeleteGratuity(item.id)}
                                  style={{ padding: "8px", border: "none", background: "transparent", cursor: "pointer" }}
                                  aria-label="Delete gratuity settings"
                                >
                                  <DeleteIconV2 />
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      {gratuityTotal > gratuityFilter.limit && (
                        <div className="w-full" style={{ marginTop: "24px" }}>
                          <div style={serviceChargePaginationContainerStyle}>
                            <p style={serviceChargePaginationTextStyle}>
                              Showing {(gratuityFilter.page - 1) * gratuityFilter.limit + 1}-
                              {Math.min(gratuityFilter.page * gratuityFilter.limit, gratuityTotal)} from {gratuityTotal}
                            </p>
                            <div style={serviceChargePaginationWrapperStyle}>
                              <button
                                type="button"
                                onClick={() => handleGratuityPageClick(gratuityFilter.page - 1)}
                                style={serviceChargeArrowButtonStyle(gratuityFilter.page === 1)}
                              >
                                <ChevronLeftIcon />
                              </button>
                              {visiblePages(gratuityFilter.page, totalGratuityPages).map((page, index) => (
                                <button
                                  key={`${page}-${index}`}
                                  type="button"
                                  onClick={() => handleGratuityPageClick(page)}
                                  disabled={page === "..."}
                                  style={getServiceChargeButtonStyle(page, page === gratuityFilter.page)}
                                >
                                  {page}
                                </button>
                              ))}
                              <button
                                type="button"
                                onClick={() => handleGratuityPageClick(gratuityFilter.page + 1)}
                                style={serviceChargeArrowButtonStyle(gratuityFilter.page === totalGratuityPages)}
                              >
                                <ChevronRightIcon />
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {!showGratuityForm && !gratuityLoading && listGratuity.length === 0 && (
                    <div
                      className="flex flex-col items-center justify-center"
                      style={{ border: "1px solid #EBF0F0", borderRadius: "12px", padding: "40px 24px", gap: "6px" }}
                    >
                      <p className="font-inter" style={{ fontSize: "16px", fontWeight: "500", color: "#222525" }}>
                        {tr("No gratuity settings yet")}
                      </p>
                      <p className="font-inter" style={{ fontSize: "14px", color: "#819596", textAlign: "center" }}>
                        {tr("Add a company default, then override it per location if needed.")}
                      </p>
                    </div>
                  )}
                  {showGratuityForm && !gratuityLoading && (
                    <div className="flex flex-col" style={{ gap: "24px", paddingBottom: "24px" }}>
                      <div className="flex" style={{ gap: "24px", flexWrap: "wrap" }}>
                        <div className="space-y-2" style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {tr("Applies to")}
                          </p>
                          <div className="w-full" style={{ height: "48px" }}>
                            <DropdownSearch
                              refKey="gratuityScope"
                              refs={gratuityDropdownRefs}
                              openStates={gratuityDropdownOpen}
                              open={openGratuityDropdown}
                              close={closeGratuityDropdown}
                              data={gratuityScopeOptions}
                              labelExtractor={(item) => item.name}
                              value={gratuityDropdownText.gratuityScope ?? ""}
                              setValue={(v) => setGratuityDropdownText((prev) => ({ ...prev, gratuityScope: v }))}
                              onSelect={(item) => {
                                setGratuityDropdownText((prev) => ({ ...prev, gratuityScope: item.name }));
                                setGratuityForm((prev) => ({ ...prev, locationId: item.id }));
                              }}
                              placeholder={tr("Company default")}
                            />
                          </div>
                        </div>
                        {renderGratuityYesNo("enable", tr("Enable"))}
                      </div>
                      <div>
                        <div className="flex items-center justify-between" style={{ marginBottom: "8px", gap: "12px", flexWrap: "wrap" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {tr("Options")}
                          </p>
                          <p className="font-inter" style={{ fontSize: "13px", lineHeight: "18px", color: "#819596" }}>
                            {tr("Shown on the till in this order; the default is preselected.")}
                          </p>
                        </div>
                        <div style={{ border: "1px solid #EBF0F0", borderRadius: "12px", overflow: "hidden" }}>
                          {gratuityForm.options.map((row, index) => (
                            <div
                              key={row.key}
                              className="flex items-end"
                              style={{
                                gap: "16px",
                                padding: "12px 16px",
                                flexWrap: "wrap",
                                borderBottom: index === gratuityForm.options.length - 1 ? "none" : "1px solid #EBF0F0",
                              }}
                            >
                              <div style={{ flex: "0 0 auto" }}>
                                <p className="text-[13px] font-inter leading-[18px]" style={{ color: "#6A7878", marginBottom: "8px" }}>
                                  {tr("Type")}
                                </p>
                                <div className="flex items-center" style={{ gap: "16px", height: "44px" }}>
                                  {GRATUITY_OPTION_TYPES.map((type) => (
                                    <label key={type.id} className="flex items-center font-inter text-[14px]" style={{ gap: "8px", color: "#4A5353", cursor: "pointer" }}>
                                      <input
                                        type="radio"
                                        name={`gratuity-type-${row.key}`}
                                        checked={row.valueType === type.id}
                                        onChange={() =>
                                          setGratuityForm((prev) => ({
                                            ...prev,
                                            options: patchGratuityOption(prev.options, row.key, { valueType: type.id }),
                                          }))
                                        }
                                        style={gratuityRadioStyle(row.valueType === type.id)}
                                      />
                                      {tr(type.name)}
                                    </label>
                                  ))}
                                </div>
                              </div>
                              <div style={{ width: "140px" }}>
                                <p className="text-[13px] font-inter leading-[18px]" style={{ color: "#6A7878", marginBottom: "8px" }}>
                                  {row.valueType === 3 ? tr("Round up step") : tr("Value")}
                                </p>
                                <input
                                  inputMode="decimal"
                                  value={row.value}
                                  onChange={(e) =>
                                    setGratuityForm((prev) => ({
                                      ...prev,
                                      options: patchGratuityOption(prev.options, row.key, { value: e.target.value }),
                                    }))
                                  }
                                  placeholder={row.valueType === 1 ? "10" : row.valueType === 2 ? "2.50" : "1.00"}
                                  aria-label={row.valueType === 3 ? tr("Round up step") : tr("Value")}
                                  className={gratuityInputClass}
                                  style={{ height: "44px" }}
                                />
                              </div>
                              <div style={{ flex: "1 1 180px", minWidth: "180px" }}>
                                <p className="text-[13px] font-inter leading-[18px]" style={{ color: "#6A7878", marginBottom: "8px" }}>
                                  {tr("Display name")}
                                </p>
                                <input
                                  value={row.displayName}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setGratuityForm((prev) => ({
                                      ...prev,
                                      options: patchGratuityOption(prev.options, row.key, { displayName: e.target.value }),
                                    }))
                                  }
                                  placeholder={tr("Optional")}
                                  aria-label={tr("Display name")}
                                  className={gratuityInputClass}
                                  style={{ height: "44px" }}
                                />
                              </div>
                              <label className="flex items-center font-inter text-[14px]" style={{ gap: "8px", color: "#4A5353", cursor: "pointer", height: "44px" }}>
                                <input
                                  type="checkbox"
                                  checked={row.isDefault}
                                  onChange={(e) =>
                                    setGratuityForm((prev) => ({
                                      ...prev,
                                      options: setDefaultGratuityOption(prev.options, row.key, e.target.checked),
                                    }))
                                  }
                                  style={{ width: 18, height: 18, margin: 0, accentColor: "#0F7679", cursor: "pointer" }}
                                />
                                {tr("Default")}
                              </label>
                              <div className="flex items-center" style={{ gap: "6px", height: "44px" }}>
                                <button
                                  type="button"
                                  onClick={() => setGratuityForm((prev) => ({ ...prev, options: moveGratuityOption(prev.options, row.key, -1) }))}
                                  disabled={index === 0}
                                  aria-label={tr("Move up")}
                                  title={tr("Move up")}
                                  style={gratuityIconButtonStyle(index === 0)}
                                >
                                  ↑
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setGratuityForm((prev) => ({ ...prev, options: moveGratuityOption(prev.options, row.key, 1) }))}
                                  disabled={index === gratuityForm.options.length - 1}
                                  aria-label={tr("Move down")}
                                  title={tr("Move down")}
                                  style={gratuityIconButtonStyle(index === gratuityForm.options.length - 1)}
                                >
                                  ↓
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setGratuityForm((prev) => ({ ...prev, options: removeGratuityOption(prev.options, row.key) }))}
                                  aria-label={tr("Remove")}
                                  title={tr("Remove")}
                                  style={gratuityIconButtonStyle(false)}
                                >
                                  <DeleteIconV2 />
                                </button>
                              </div>
                            </div>
                          ))}
                          {gratuityForm.options.length === 0 && (
                            <p className="font-inter" style={{ padding: "24px 16px", fontSize: "14px", color: "#819596", textAlign: "center" }}>
                              {tr("No options yet. Add at least one preset.")}
                            </p>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => setGratuityForm((prev) => ({ ...prev, options: [...prev.options, newGratuityOptionRow()] }))}
                          className="font-inter cursor-pointer flex items-center"
                          style={{
                            marginTop: "12px",
                            borderRadius: "30px",
                            padding: "8px 16px",
                            border: "1px solid #0F7679",
                            background: "transparent",
                            color: "#0F7679",
                            fontSize: "14px",
                            fontWeight: "500",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontSize: "18px", lineHeight: 1 }}>+</span>
                          <span>{tr("Add option")}</span>
                        </button>
                      </div>
                      <div className="flex" style={{ gap: "24px", flexWrap: "wrap" }}>
                        <div className="space-y-2" style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {tr("Prompt mode")}
                          </p>
                          <div className="w-full" style={{ height: "48px" }}>
                            <DropdownSearch
                              refKey="gratuityPromptMode"
                              refs={gratuityDropdownRefs}
                              openStates={gratuityDropdownOpen}
                              open={openGratuityDropdown}
                              close={closeGratuityDropdown}
                              data={GRATUITY_PROMPT_MODES.map((mode) => ({ id: mode.id, name: tr(mode.name) }))}
                              labelExtractor={(item) => item.name}
                              value={gratuityDropdownText.gratuityPromptMode ?? ""}
                              setValue={(v) => setGratuityDropdownText((prev) => ({ ...prev, gratuityPromptMode: v }))}
                              onSelect={(item) => {
                                setGratuityDropdownText((prev) => ({ ...prev, gratuityPromptMode: item.name }));
                                setGratuityForm((prev) => ({ ...prev, promptMode: item.id }));
                              }}
                              placeholder={tr("Prompt mode")}
                            />
                          </div>
                        </div>
                        <div className="space-y-2" style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
                          <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                            {tr("Percent base")}
                          </p>
                          <div className="w-full" style={{ height: "48px" }}>
                            <DropdownSearch
                              refKey="gratuityPercentBase"
                              refs={gratuityDropdownRefs}
                              openStates={gratuityDropdownOpen}
                              open={openGratuityDropdown}
                              close={closeGratuityDropdown}
                              data={GRATUITY_PERCENT_BASES.map((base) => ({ id: base.id, name: tr(base.name) }))}
                              labelExtractor={(item) => item.name}
                              value={gratuityDropdownText.gratuityPercentBase ?? ""}
                              setValue={(v) => setGratuityDropdownText((prev) => ({ ...prev, gratuityPercentBase: v }))}
                              onSelect={(item) => {
                                setGratuityDropdownText((prev) => ({ ...prev, gratuityPercentBase: item.name }));
                                setGratuityForm((prev) => ({ ...prev, percentBase: item.id }));
                              }}
                              placeholder={tr("Percent base")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex" style={{ gap: "24px", flexWrap: "wrap" }}>
                        {renderGratuityYesNo("taxable", tr("Taxable"))}
                        {gratuityForm.taxable === "yes" && (
                          <div className="space-y-2" style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                              {tr("Tax group")}
                            </p>
                            <div className="w-full" style={{ height: "48px" }}>
                              <DropdownSearch
                                refKey="gratuityTaxGroup"
                                refs={gratuityDropdownRefs}
                                openStates={gratuityDropdownOpen}
                                open={openGratuityDropdown}
                                close={closeGratuityDropdown}
                                data={gratuityTaxGroups}
                                labelExtractor={(item) => item.name}
                                value={gratuityDropdownText.gratuityTaxGroup ?? ""}
                                setValue={(v) => setGratuityDropdownText((prev) => ({ ...prev, gratuityTaxGroup: v }))}
                                onSelect={(item) => {
                                  setGratuityDropdownText((prev) => ({ ...prev, gratuityTaxGroup: item.name }));
                                  setGratuityForm((prev) => ({ ...prev, taxGroupId: item.id }));
                                }}
                                placeholder={tr("Select tax group")}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="flex" style={{ gap: "24px", flexWrap: "wrap" }}>
                        {renderGratuityYesNo("allowCustom", tr("Allow custom gratuity"))}
                        {gratuityForm.allowCustom === "yes" && (
                          <div className="space-y-2" style={{ width: "calc(50% - 12px)", minWidth: "220px" }}>
                            <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#4A5353", fontWeight: "500" }}>
                              {tr("Maximum custom %")}
                            </p>
                            <input
                              inputMode="decimal"
                              value={gratuityForm.customMaxPercent}
                              {...limitProps(gratuityLimits, "customMaxPercent", "number")}
                              onChange={(e) => setGratuityForm((prev) => ({ ...prev, customMaxPercent: e.target.value }))}
                              placeholder={tr("No limit")}
                              className={gratuityInputClass}
                            />
                            {gratuityErrors.customMaxPercent && <p className="error">{gratuityErrors.customMaxPercent}</p>}
                          </div>
                        )}
                      </div>
                      <div className="flex" style={{ gap: "24px", flexWrap: "wrap" }}>
                        {renderGratuityYesNo("cashChange", tr("Offer cash change as gratuity"))}
                        {renderGratuityYesNo("roundUpExact", tr("Round up to the next step when already exact"))}
                      </div>
                    </div>
                  )}
                </form>
              </>
            )}
          </div>
        </div>
        {
          (tab === "company" || tab === "invoice" || (tab === "serviceCharge" && showServiceChargeForm) || (tab === "gratuity" && showGratuityForm)) &&
          <div
            className="w-full flex items-center justify-end shadow_button relative"
            style={{ gap: "12px", paddingTop: "24px", }}
          >
            <div className="absolute" style={{ left: 0, top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? '100%' : "calc(100vw - 256px)" }}></div>
            <button
              type="button"
              {...kb.primaryProps((e: any) => {
                if (tab === "invoice") {
                  return handleSaveInvoiceConfig(e);
                } else if (tab === "serviceCharge") {
                  return handleSaveServiceCharge(e);
                } else if (tab === "gratuity") {
                  return handleSaveGratuity(e);
                } else {
                  return handleSubmit(e);
                }
              })}
              style={{
                borderRadius: "30px",
                color: "#FFFFFF",
                fontSize: "14px",
                fontWeight: "500",
                backgroundColor: "#0F7679",
                padding: "10px 24px",
              }}
              className="font-inter cursor-pointer"
            >
              <p className="text-[14px] leading-[22px] font-inter">
                {language && language?.["Save"] ? language?.["Save"] : "Save"}
              </p>
            </button>
          </div>
        }
      </div>
      <div
        ref={billingDialogRef}
        role="dialog"
        aria-modal="true"
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showPopupBilling ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          visibility: showPopupBilling ? "visible" : "hidden",
          width: "100%",
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showPopupBilling ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
            width: "520px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p
              style={{ fontSize: "20px", color: "#222525" }}
              className="font-semibold font-inter leading-[24px]"
            >
              {language && language?.["Cancel Subscription"]
                ? language?.["Cancel Subscription"]
                : "Cancel Subscription"}
            </p>
            <button
              type="button"
              aria-label={language?.["Close"] ?? "Close"}
              onClick={() => {
                setShowPopupBilling(false);
              }}
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="" style={{ marginTop: "12px" }}>
            <p
              style={{ fontSize: "14px", color: "#6A7878" }}
              className="font-semibold font-inter leading-[24px]"
            >
              {language &&
                language?.[
                "Your plan will be canceled, but is still available until the end of your current billing period on 31/01/2026. If you change your mind, you can renew your subscription."
                ]
                ? language?.[
                "Your plan will be canceled, but is still available until the end of your current billing period on 31/01/2026. If you change your mind, you can renew your subscription."
                ]
                : "Your plan will be canceled, but is still available until the end of your current billing period on 31/01/2026. If you change your mind, you can renew your subscription."}
            </p>
          </div>
          <div
            className="w-full flex items-center justify-end"
            style={{ marginTop: "24px", gap: "12px" }}
          >
            <button
              type="button"
              onClick={() => {
                setShowPopupBilling(false);
              }}
              style={{
                padding: "10px 24px",
                borderRadius: "30px",
                color: "#222525",
                fontSize: "14px",
                fontWeight: "500",
                border: "1px solid #C9D7D8",
              }}
              className="font-inter cursor-pointer"
            >
              {language && language?.["Cancel"]
                ? language?.["Cancel"]
                : "Cancel"}
            </button>
            <button
              type="button"
              style={{
                padding: "10px 24px",
                borderRadius: "30px",
                color: "#FFFFFF",
                fontSize: "14px",
                fontWeight: "500",
                backgroundColor: "#BA0E13",
              }}
              className="font-inter cursor-pointer"
              onClick={() => {
                setShowPopupBilling(false);
              }}
            >
              <p className="text-[14px] leading-[22px] font-inter">
                {language && language?.["Cancel subscription"]
                  ? language?.["Cancel subscription"]
                  : "Cancel subscription"}
              </p>
            </button>
          </div>
        </div>
      </div>
      {/* Bank detail create/edit modal */}
      <div
        ref={bankDialogRef}
        role="dialog"
        aria-modal="true"
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showBankModal ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          visibility: showBankModal ? "visible" : "hidden",
          width: "100%",
        }}
      >
        <div {...bankKb.scopeProps}>
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showBankModal ? "translate-y-0" : "translate-y-4 opacity-0"} font-inter`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
            width: "520px",
            maxWidth: "100%",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between" style={{ marginBottom: "20px" }}>
            <p style={{ fontSize: "20px", color: "#222525", fontWeight: "600" }}>
              {editingBankId
                ? (language?.["Edit bank detail"] ?? "Edit bank detail")
                : (language?.["Add bank detail"] ?? "Add bank detail")}
            </p>
            <button type="button" aria-label={language?.["Close"] ?? "Close"} onClick={closeBankModal} className="flex items-center justify-center cursor-pointer" style={{ width: "24px", height: "24px" }}>
              <CloseIcon />
            </button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div className="space-y-2">
              <p className="text-[14px] font-inter" style={{ color: "#4A5353", fontWeight: "500" }}>
                {language?.["Bank name"] ?? "Bank name"} <span style={{ color: "#BA0E13" }}>*</span>
              </p>
              <input
                name="bankName"
                {...limitProps(bankLimits, "bankName")}
                value={bankFormValues.bankName}
                onChange={handleBankFormChange}
                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                placeholder={language?.["e.g. My Bank"] ?? "e.g. My Bank"}
              />
              <FieldCounter value={bankFormValues.bankName} max={bankLimits.bankName?.maxLength} />
              {bankFormErrors.bankName && <p className="error">{bankFormErrors.bankName}</p>}
            </div>
            <div className="space-y-2">
              <p className="text-[14px] font-inter" style={{ color: "#4A5353", fontWeight: "500" }}>IBAN</p>
              <input
                name="IBAN"
                {...limitProps(bankLimits, "IBAN")}
                value={bankFormValues.IBAN ?? ""}
                onChange={handleBankFormChange}
                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                placeholder="e.g. XX00 0000 0000 0000 0000 0000"
              />
              <FieldCounter value={bankFormValues.IBAN} max={bankLimits.IBAN?.maxLength} />
              {bankFormErrors.IBAN && <p className="error">{bankFormErrors.IBAN}</p>}
            </div>
            <div className="space-y-2">
              <p className="text-[14px] font-inter" style={{ color: "#4A5353", fontWeight: "500" }}>SWIFT / BIC</p>
              <input
                name="SWIFT"
                {...limitProps(bankLimits, "SWIFT")}
                value={bankFormValues.SWIFT ?? ""}
                onChange={handleBankFormChange}
                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                placeholder="e.g. XXXXXXXX"
              />
              <FieldCounter value={bankFormValues.SWIFT} max={bankLimits.SWIFT?.maxLength} />
              {bankFormErrors.SWIFT && <p className="error">{bankFormErrors.SWIFT}</p>}
            </div>
            <div className="space-y-2">
              <p className="text-[14px] font-inter" style={{ color: "#4A5353", fontWeight: "500" }}>
                {language?.["Account number"] ?? "Account number"}
              </p>
              <input
                name="accountNo"
                {...limitProps(bankLimits, "accountNo")}
                value={bankFormValues.accountNo ?? ""}
                onChange={handleBankFormChange}
                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
              />
              <FieldCounter value={bankFormValues.accountNo} max={bankLimits.accountNo?.maxLength} />
              {bankFormErrors.accountNo && <p className="error">{bankFormErrors.accountNo}</p>}
            </div>
            <div className="space-y-2">
              <p className="text-[14px] font-inter" style={{ color: "#4A5353", fontWeight: "500" }}>
                {language?.["Bank location"] ?? "Bank location"}
              </p>
              <input
                name="bankLocation"
                {...limitProps(bankLimits, "bankLocation")}
                value={bankFormValues.bankLocation ?? ""}
                onChange={handleBankFormChange}
                className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                placeholder={language?.["e.g. City, Country"] ?? "e.g. City, Country"}
              />
              <FieldCounter value={bankFormValues.bankLocation} max={bankLimits.bankLocation?.maxLength} />
              {bankFormErrors.bankLocation && <p className="error">{bankFormErrors.bankLocation}</p>}
            </div>
          </div>
          <div className="w-full flex items-center justify-end" style={{ marginTop: "24px", gap: "12px" }}>
            <button
              type="button"
              onClick={closeBankModal}
              className="font-inter cursor-pointer"
              style={{
                padding: "10px 24px",
                borderRadius: "30px",
                color: "#222525",
                fontSize: "14px",
                fontWeight: "500",
                border: "1px solid #C9D7D8",
                backgroundColor: "transparent",
              }}
            >
              {language?.["Cancel"] ?? "Cancel"}
            </button>
            <button
              type="button"
              {...bankKb.primaryProps(handleSaveBankDetail)}
              className="font-inter cursor-pointer"
              style={{
                padding: "10px 24px",
                borderRadius: "30px",
                color: "#FFFFFF",
                fontSize: "14px",
                fontWeight: "500",
                backgroundColor: "#0F7679",
                border: "none",
              }}
            >
              {language?.["Save"] ?? "Save"}
            </button>
          </div>
        </div>
        </div>
      </div>
      <PopupLocation
        show={showPopup}
        title={"Company "}
        desc={messageErr}
        onClose={handleClosePopup}
        onOpen={handleOpenPopup}
      />
      <div
        ref={deleteServiceChargeDialogRef}
        role="dialog"
        aria-modal="true"
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showDeleteServiceCharge ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "210",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          visibility: showDeleteServiceCharge ? "visible" : "hidden",
          width: "100vw",
          height: "100vh",
          left: 0,
          top: 0,
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showDeleteServiceCharge ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "#FFFFFF",
            width: "530px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p
              style={{ fontSize: "20px", color: "#222525" }}
              className="font-semibold font-inter leading-[24px]"
            >
              {language && language?.["Delete Service charge?"]
                ? language?.["Delete Service charge?"]
                : "Delete Service charge?"}
            </p>
            <button
              type="button"
              aria-label={language?.["Close"] ?? "Close"}
              onClick={() => {
                setShowDeleteServiceCharge(false);
                setIdDeleteServiceCharge("");
              }}
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <p
              className="text-[14px] font-inter leading-[24px]"
              style={{ color: "#6A7878" }}
            >
              {language && language?.["You will permanently delete the service charge"]
                ? language?.["You will permanently delete the service charge"]
                : "You will permanently delete the service charge"}
            </p>
          </div>
          <div
            className="flex items-center justify-end"
            style={{ marginTop: "24px", gap: "12px" }}
          >
            <button
              type="button"
              onClick={() => {
                setShowDeleteServiceCharge(false);
                setIdDeleteServiceCharge("");
              }}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                border: "1px solid #C9D7D8",
                color: "#222525",
              }}
            >
              {language && language?.["Cancel"]
                ? language?.["Cancel"]
                : "Cancel"}
            </button>
            <button
              type="button"
              onClick={handleDeleteServiceCharge}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                backgroundColor: "#BA0E13",
                color: "#FFFFFF",
              }}
            >
              {language && language?.["Delete"]
                ? language?.["Delete"]
                : "Delete"}
            </button>
          </div>
        </div>
      </div>
      <div
        ref={deleteGratuityDialogRef}
        role="dialog"
        aria-modal="true"
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showDeleteGratuity ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "210",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          visibility: showDeleteGratuity ? "visible" : "hidden",
          width: "100vw",
          height: "100vh",
          left: 0,
          top: 0,
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showDeleteGratuity ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "#FFFFFF",
            width: "530px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p
              style={{ fontSize: "20px", color: "#222525" }}
              className="font-semibold font-inter leading-[24px]"
            >
              {tr("Delete gratuity settings?")}
            </p>
            <button
              type="button"
              aria-label={tr("Close")}
              onClick={() => {
                setShowDeleteGratuity(false);
                setIdDeleteGratuity("");
              }}
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <p
              className="text-[14px] font-inter leading-[24px]"
              style={{ color: "#6A7878" }}
            >
              {tr("You will permanently delete the gratuity settings")}
            </p>
          </div>
          <div
            className="flex items-center justify-end"
            style={{ marginTop: "24px", gap: "12px" }}
          >
            <button
              type="button"
              onClick={() => {
                setShowDeleteGratuity(false);
                setIdDeleteGratuity("");
              }}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                border: "1px solid #C9D7D8",
                color: "#222525",
              }}
            >
              {tr("Cancel")}
            </button>
            <button
              type="button"
              onClick={handleDeleteGratuity}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                backgroundColor: "#BA0E13",
                color: "#FFFFFF",
              }}
            >
              {tr("Delete")}
            </button>
          </div>
        </div>
      </div>
      <div
        ref={deleteDialogRef}
        role="dialog"
        aria-modal="true"
        className={`absolute  h-full top-0 left-0 flex items-center justify-center ${showDelete ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          visibility: showDelete ? "visible" : "hidden",
          width: "100%",
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showDelete ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
            width: "520px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p className="text-[16px] font-semibold font-inter text-main leading-[24px]">
              {language && language?.["Delete Item"]
                ? language?.["Delete Item"]
                : "Delete Item"}
            </p>
            <button
              type="button"
              aria-label={language?.["Close"] ?? "Close"}
              onClick={() => setShowDelete(false)}
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "100%",
                backgroundColor: "#D1E4E5",
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div
            className="flex items-center justify-between"
            style={{ padding: "20px 16px" }}
          >
            <p className="text-[16px] font-semibold font-inter text-main leading-[24px]">
              {tab === "user"
                ? language?.["You will permanently delete the user"] ?? "You will permanently delete the user"
                : tab === "location"
                  ? language?.["You will permanently delete the location"] ?? "You will permanently delete the location"
                  : language?.["You will permanently delete the floor plan"] ?? "You will permanently delete the floor plan"}
            </p>
            {/* <span className="text-main">[sale ID]</span> sale. */}
          </div>
          <div
            className="flex items-center gap-x-3"
            style={{ padding: "0px 16px 12px 16px" }}
          >
            <button
              type="button"
              onClick={() => setShowDelete(false)}
              className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-inter flex items-center justify-center"
              style={{
                borderRadius: "6px",
                height: "40px",
                border: "1px solid #DEDEE2",
                color: "#1E1E36",
              }}
            >
              {language && language?.["Not Now"]
                ? language?.["Not Now"]
                : "Not Now"}
            </button>
            <button
              type="button"
              onClick={() => handleDeleteItem()}
              className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-inter flex items-center justify-center font-medium"
              style={{
                borderRadius: "6px",
                height: "40px",
                backgroundColor: "#E40F03",
                color: "#F9F9F9",
              }}
            >
              {language && language?.["Delete"]
                ? language?.["Delete"]
                : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Company;
